import React, {
  forwardRef,
  useImperativeHandle,
  useEffect,
  useState
} from "react";
import { useIntl } from "react-intl";

export const ExpiryAnimation = forwardRef((props, timerRef) => {
  let { min } = props;
  const [secondsLeft, setSecondsLeft] = useState(0);

  useImperativeHandle(timerRef, () => ({
    //Sending function to parent components
    changeTimer(second) {
      setSecondsLeft(second);
    }
  }));

  useEffect(() => {
    const id = setInterval(() => {
      if (secondsLeft < 1) {
        setSecondsLeft(0);
        props.setResendButton();
        clearInterval(id);
      } else {
        setSecondsLeft(secondsLeft - 1);
      }
    }, 1000);
    return () => clearInterval(id);
  }, [secondsLeft, props]);

  return (
    <div className="position-relative d-flex">
      <svg
        className="base-timer__svg"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g className="base-timer__circle">
          <circle
            className="base-timer__path-elapsed"
            cx="50"
            cy="50"
            r="45"
          ></circle>
          <path
            id="base-timer-path-remaining"
            strokeDasharray={`${Math.floor(
              (secondsLeft / (min * 60)) * 283
            )} 283`}
            stroke={
              Math.floor((secondsLeft / (min * 60)) * 283) > 15
                ? props.fillColor
                  ? props.fillColor
                  : "#3699FF"
                : Math.floor((secondsLeft / (min * 60)) * 283) === 0
                ? ""
                : "#FF4B55"
            }
            className="base-timer__path-remaining"
            d="M 50, 50 m -45, 0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0"
          />
        </g>
      </svg>
      <div
        className="timer-text"
        style={props.fontColor && { color: props.fontColor }}
      >
        {Math.ceil(secondsLeft / 60)}
        <p className="timer-desc-text">Min</p>
      </div>
    </div>
  );
});
export const DashboardTimer = props => {
  const intl = useIntl();
  let { sec, totalSec } = props;
  return (
    <div className="position-relative d-flex">
      <svg
        className="base-timer__svg"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g className="base-timer__circle">
          <circle
            className="base-timer__path-elapsed"
            cx="50"
            cy="50"
            r="45"
          ></circle>
          <path
            id="base-timer-path-remaining"
            strokeDasharray={`${Math.floor((sec / totalSec) * 283)} 283`}
            stroke={
              Math.floor((sec / totalSec) * 283) > 15
                ? props.fillColor
                  ? props.fillColor
                  : "#3699FF"
                : Math.floor((sec / totalSec) * 283) === 0
                ? ""
                : "#FF4B55"
            }
            className="base-timer__path-remaining"
            d="M 50, 50 m -45, 0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0"
          />
        </g>
      </svg>
      <div
        className="timer-text"
        style={props.fontColor && { color: props.fontColor }}
      >
        {Math.ceil(sec)}
        <p className="timer-desc-text">{intl.formatMessage({ id: "SEC" })}</p>
      </div>
    </div>
  );
};

export const MenuIcon = () => {
  return (
    <svg
      width="18"
      height="11"
      viewBox="0 0 18 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.562486 1.62497L17.4375 1.62497C17.748 1.62497 18 1.37295 18 1.06248C18 0.751972 17.7479 0.499998 17.4375 0.499998L0.562485 0.5C0.251973 0.5 2.20323e-08 0.75202 4.91741e-08 1.06249C7.63159e-08 1.37295 0.25202 1.62497 0.562486 1.62497Z"
        fill="#3699FF"
      />
      <path
        d="M17.4375 5.03039L0.562485 5.0304C0.251973 5.0304 2.20322e-08 5.28241 4.91739e-08 5.59288C7.63156e-08 5.90334 0.25202 6.15536 0.562486 6.15536L17.4375 6.15536C17.748 6.15536 18 5.90334 18 5.59288C18 5.28241 17.748 5.03039 17.4375 5.03039Z"
        fill="#3699FF"
      />
      <path
        d="M17.4375 9.56079L6.18749 9.56079C5.87697 9.56079 5.625 9.81281 5.625 10.1233C5.625 10.4338 5.87702 10.6858 6.18749 10.6858L17.4375 10.6858C17.748 10.6858 18 10.4337 18 10.1233C18 9.81276 17.748 9.56079 17.4375 9.56079Z"
        fill="#3699FF"
      />
    </svg>
  );
};
export const Logo = () => {
  return (
    <svg
      width="127"
      height="42"
      viewBox="0 0 127 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5168 3.45024C19.5168 6.10427 19.5168 8.75829 19.5168 11.4123C15.3035 11.4455 11.8865 14.8626 11.8865 19.0758C11.8865 23.2891 15.2704 26.7062 19.4836 26.7393C19.4836 30.6209 19.4836 34.5024 19.4836 38.3839C29.9339 32.1469 36.9007 22.8578 35.5073 5.97156C30.9955 4.21327 25.8865 3.64929 19.5168 3.45024ZM19.4836 42C6.94334 34.5024 -1.45003 23.3223 0.208737 2.98578C10.4267 -0.995261 28.5737 -0.995261 38.7917 2.98578C40.4836 23.3223 32.0239 34.5024 19.4836 42Z"
        fill="#2C2C70"
      />
      <path
        d="M19.5506 8.92419C13.944 8.92419 9.39893 13.4692 9.39893 19.0759C9.39893 24.6825 13.944 29.2275 19.5506 29.2275C25.1572 29.2275 29.7022 24.6825 29.7022 19.0759C29.7022 13.4692 25.1572 8.92419 19.5506 8.92419ZM14.6738 18.0142L17.5601 20.5356C22.9676 15.128 24.7923 14.0332 24.7923 14.0332C24.7923 14.0332 25.1572 14.0332 25.5222 14.7299C22.271 17.6161 18.2899 24.1185 18.2899 24.1185C18.2899 24.1185 16.8302 22.327 13.579 19.0759L14.6738 18.0142Z"
        fill="#E64110"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.839 7.46448C79.6968 7.46448 81.1897 8.95737 81.1897 10.8152C81.1897 12.673 79.6968 14.1659 77.839 14.1659C75.9812 14.1659 74.4883 12.673 74.4883 10.8152C74.4883 8.99054 75.9812 7.46448 77.839 7.46448Z"
        fill="#E64110"
      />
      <path
        d="M92.2375 12.3743C94.8915 12.3743 96.8157 13.0046 98.0763 14.2985C99.337 15.5923 99.9342 17.616 99.9342 20.3696C99.9342 22.8909 99.2375 24.8482 97.8773 26.2748C96.5171 27.6681 94.5929 28.3648 92.1711 28.3648H89.0526L84.2754 32.5118H92.4034C94.5929 32.5118 96.3844 32.2795 97.7114 31.8482C99.0384 31.417 100.233 30.6539 101.328 29.6255C102.489 28.5307 103.351 27.1705 103.915 25.5781C104.512 23.9857 104.811 22.2274 104.811 20.2369C104.811 18.0473 104.413 16.0568 103.583 14.3317C102.754 12.5734 101.56 11.1468 100.001 10.0189C99.1048 9.35535 98.1095 8.8909 97.0147 8.62549C95.9199 8.36009 94.427 8.19421 92.5692 8.19421H84.3086V25.7108H89.0858V12.3743H92.2375Z"
        fill="#2C2C70"
      />
      <path
        d="M59.925 12.3743C62.579 12.3743 64.5032 13.0046 65.7638 14.2985C67.0245 15.5923 67.6217 17.616 67.6217 20.3696C67.6217 22.8909 66.925 24.8482 65.5648 26.2748C64.2046 27.6681 62.2804 28.3648 59.8586 28.3648H56.7401L51.9629 32.5118H60.0909C62.2804 32.5118 64.0719 32.2795 65.3989 31.8482C66.7259 31.417 67.9202 30.6539 69.015 29.6255C70.1762 28.5307 71.0387 27.1705 71.6027 25.5781C72.1999 23.9857 72.4984 22.2274 72.4984 20.2369C72.4984 18.0473 72.1003 16.0568 71.2709 14.3317C70.4416 12.5734 69.2472 11.1468 67.688 10.0189C66.7923 9.35535 65.797 8.8909 64.7022 8.62549C63.6074 8.36009 62.1145 8.19421 60.2567 8.19421H51.9961V25.7108H56.7401V12.3743H59.925Z"
        fill="#2C2C70"
      />
      <path
        d="M75.6162 32.4786V19.8056L80.3935 15.6255V32.4786H75.6162Z"
        fill="#2C2C70"
      />
      <path
        d="M111.844 21.1992V21.2324V21.2656V21.2988V21.3319V21.3651V21.3983V21.4315V21.4646V21.4978V21.531V21.5642V21.5973V21.6305V21.6637V21.6969V21.73V21.7632V21.7964V21.8296V21.8627V21.8959V21.9291V21.9623V21.9954V22.0286V22.0618V22.095V22.1281V22.1613V22.1945V22.2277V22.2608V22.294V22.3272V22.3604V22.3935V22.4267V22.4599V22.4931V22.5262V22.5594V22.5926V22.6258V22.6589V22.6921V22.7585V22.7916V22.8248V22.858V22.8912V22.9243V22.9575V22.9907V23.0239V23.057V23.0902V23.1234V23.1566V23.1897V23.2229V23.2561V23.2893V23.3224V23.3556V23.3888V23.422V23.4551V23.4883V23.5215V23.5547V23.621V23.6542V23.6874V23.7206V23.7537V23.7869V23.8201V23.8533V23.8864V23.9196V23.9528V23.986V24.0191V24.0523V24.0855V24.1187V24.1518V24.185V24.2182V24.2514V24.2845V24.3177V24.3509V24.3841V24.4172V24.4504V24.4836V24.5168V24.5499V24.5831V24.6163V24.6495V24.6826V24.7158V24.749V24.7822V24.8153V24.8485V24.8817V24.9149V24.948V24.9812V25.0144V25.0476V25.0807V25.1139V25.1471V25.1803V25.2134V25.2466V25.2798V25.313V25.3461V25.3793V25.4125V25.4457V25.4788V25.512C112.076 26.1092 112.441 26.6732 112.938 27.1708C113.934 28.1992 115.128 28.73 116.521 28.73C118.114 28.73 119.441 28.2324 120.469 27.1708C121.498 26.1424 122.028 24.8485 122.028 23.2893C122.028 21.8296 121.498 20.5357 120.469 19.4741C119.441 18.4125 118.18 17.8817 116.687 17.8817C115.194 17.8817 113.934 18.4125 112.938 19.4741C112.474 20.0049 112.076 20.5689 111.844 21.1992ZM107.066 32.4788V11.6779L111.844 7.4978V15.3604C113.37 14.2656 115.128 13.7348 117.152 13.7348C119.739 13.7348 121.962 14.6969 123.82 16.5547C125.678 18.4457 126.574 20.7016 126.574 23.3224C126.574 26.076 125.645 28.3319 123.82 30.1566C121.962 31.9812 119.64 32.877 116.82 32.877C114.962 32.877 113.303 32.3793 111.877 31.3509V32.4788H107.066Z"
        fill="#2C2C70"
      />
    </svg>
  );
};
export const HelpIcon = () => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.558 24.1627L21.5249 26.748C21.0891 26.3089 20.4856 26.0365 19.8195 26.0365H16.3512C16.197 26.0365 16.1405 26.027 16.1236 26.0229C16.0921 26.0016 16.0137 25.9278 15.9501 25.868L15.917 25.8367C13.094 23.1784 10.7086 23.347 7.99568 24.4177C7.57112 24.5852 7.56305 24.5855 7.14225 24.6047L6.37824 24.6057C6.13974 23.9297 5.49542 23.4438 4.7396 23.4438H2.18774C1.22966 23.4438 0.450195 24.2242 0.450195 25.1834V31.8759C0.450195 32.834 1.22966 33.6135 2.18774 33.6135H4.73954C5.49542 33.6135 6.13974 33.1282 6.37824 32.4529H7.78152C7.94038 32.4666 8.09527 32.499 8.24627 32.5498L14.8452 34.3144C15.1341 34.3927 15.3994 34.4698 15.656 34.5444C16.5082 34.792 17.2246 35.0002 17.9715 35.0001C18.8153 35.0001 19.6982 34.7344 20.8595 33.9597C20.8653 33.9558 20.8711 33.9519 20.8768 33.9479L29.013 28.1541C30.0825 27.391 30.3943 26.0137 29.738 24.9498C29.0892 23.9009 27.7217 23.5627 26.558 24.1627ZM5.10996 31.876C5.10996 32.0768 4.9403 32.2465 4.73954 32.2465H2.18774C1.98691 32.2465 1.81732 32.0768 1.81732 31.876V25.1834C1.81732 24.9816 1.98698 24.811 2.18774 24.811H4.73954C4.94037 24.811 5.10996 24.9816 5.10996 25.1834V31.876ZM28.2194 27.0409L20.0922 32.8282C18.438 33.9292 17.734 33.7246 16.0373 33.2316C15.7749 33.1554 15.5036 33.0766 15.2005 32.9943L8.59988 31.2293C8.33431 31.147 8.06144 31.0991 7.78138 31.0858H6.47708V25.9736L7.20446 25.9705C7.72471 25.9468 7.88603 25.9306 8.49741 25.6895C10.8489 24.7613 12.6634 24.6508 14.9803 26.8326L15.013 26.8634C15.412 27.239 15.6591 27.4035 16.3512 27.4035H19.8195C20.3913 27.4035 20.8565 27.8687 20.8565 28.4405C20.8565 29.0113 20.3913 29.4756 19.8195 29.4756H14.1967C13.8192 29.4756 13.5132 29.7817 13.5132 30.1592C13.5132 30.5367 13.8192 30.8428 14.1967 30.8428H19.8195C21.1451 30.8428 22.2236 29.7651 22.2236 28.4405C22.2236 28.2731 22.2062 28.1096 22.1735 27.9517L27.1834 25.3783C27.6401 25.1429 28.2648 25.167 28.5747 25.6683C28.848 26.1113 28.695 26.7016 28.2194 27.0409Z"
        fill="#3699FF"
      />
      <path
        d="M16.1847 16.1682C15.4447 16.5286 14.9335 17.2883 14.9335 18.1653C14.9335 19.1322 15.5561 19.956 16.4215 20.2589V21.277C16.4215 22.5236 17.4348 23.5378 18.6803 23.5378H21.7087C22.9552 23.5378 23.9694 22.5236 23.9694 21.277V20.2589C24.8349 19.956 25.4575 19.1321 25.4575 18.1653C25.4575 17.2883 24.9462 16.5285 24.2062 16.1681C24.5055 15.0561 25.1123 14.2281 25.7505 13.3596C26.7322 12.0235 27.8449 10.5091 27.8425 7.84166C27.8425 7.6035 27.8327 7.35906 27.8133 7.1151C27.7833 6.73873 27.4548 6.45881 27.0776 6.48787C26.7013 6.51781 26.4205 6.84714 26.4505 7.22351C26.467 7.43152 26.4754 7.63946 26.4754 7.8422C26.4774 10.0613 25.5892 11.2702 24.6487 12.55C23.9352 13.5212 23.2008 14.5222 22.8509 15.9451H17.5398C17.1899 14.5224 16.4553 13.5214 15.7416 12.5503C14.8009 11.2705 13.9124 10.0616 13.9153 7.84241C13.9183 5.47613 14.9321 3.98173 15.7821 3.14478C16.9525 1.99229 18.5557 1.34455 20.1857 1.36752C20.1923 1.36759 20.1988 1.36759 20.2053 1.36752C21.5334 1.34735 22.8654 1.78025 23.9528 2.58419C24.2562 2.8086 24.6844 2.74442 24.9088 2.44091C25.1332 2.13735 25.0691 1.7093 24.7656 1.48489C23.4416 0.506165 21.8189 -0.0203814 20.1953 0.000603902C18.2069 -0.0236625 16.2498 0.765918 14.823 2.17091C13.3378 3.63345 12.5512 5.59411 12.5483 7.84084C12.5448 10.5094 13.658 12.024 14.6402 13.3602C15.2784 14.2285 15.8854 15.0564 16.1847 16.1682ZM22.6024 21.2771C22.6024 21.7699 22.2015 22.1708 21.7087 22.1708H18.6804C18.1887 22.1708 17.7887 21.7699 17.7887 21.2771V20.3835H22.6024V21.2771ZM17.1536 17.3123H23.2375C23.7077 17.3123 24.0904 17.695 24.0904 18.1653C24.0904 18.6345 23.7078 19.0163 23.2375 19.0163H17.1536C16.6833 19.0163 16.3006 18.6345 16.3006 18.1653C16.3006 17.695 16.6833 17.3123 17.1536 17.3123Z"
        fill="#3699FF"
      />
      <path
        d="M20.8788 4.99362C20.8788 4.61609 20.5728 4.31006 20.1953 4.31006C19.8177 4.31006 19.5117 4.61609 19.5117 4.99362V9.23313C19.5117 9.61066 19.8177 9.91669 20.1953 9.91669C20.5728 9.91669 20.8788 9.61066 20.8788 9.23313V4.99362Z"
        fill="#3699FF"
      />
      <path
        d="M20.1953 11.6416C19.8178 11.6416 19.5117 11.9476 19.5117 12.3252V12.3291C19.5117 12.7066 19.8178 13.0108 20.1953 13.0108C20.5729 13.0108 20.8789 12.7028 20.8789 12.3253C20.8789 11.9477 20.5729 11.6416 20.1953 11.6416Z"
        fill="#3699FF"
      />
      <path
        d="M33.8668 7.83643H31.0903C30.7128 7.83643 30.4067 8.14246 30.4067 8.51998C30.4067 8.89751 30.7128 9.20354 31.0903 9.20354H33.8668C34.2443 9.20354 34.5503 8.89751 34.5503 8.51998C34.5503 8.14246 34.2443 7.83643 33.8668 7.83643Z"
        fill="#3699FF"
      />
      <path
        d="M29.9421 3.43348C30.0731 3.43348 30.2055 3.39588 30.3224 3.31741L32.6261 1.7712C32.9396 1.5608 33.0231 1.13617 32.8127 0.822688C32.6024 0.509276 32.1778 0.425677 31.8642 0.636076L29.5605 2.18229C29.247 2.39269 29.1635 2.81739 29.3739 3.1308C29.5059 3.32732 29.722 3.43348 29.9421 3.43348Z"
        fill="#3699FF"
      />
      <path
        d="M32.6261 15.2687L30.3224 13.7225C30.0089 13.5121 29.5842 13.5957 29.3739 13.9091C29.1635 14.2225 29.2471 14.6472 29.5605 14.8576L31.8642 16.4038C31.9811 16.4823 32.1135 16.5199 32.2445 16.5199C32.4647 16.5199 32.6808 16.4138 32.8127 16.2172C33.0231 15.9037 32.9396 15.479 32.6261 15.2687Z"
        fill="#3699FF"
      />
      <path
        d="M6.52389 9.20354H9.29847C9.676 9.20354 9.98203 8.89751 9.98203 8.51998C9.98203 8.14246 9.676 7.83643 9.29847 7.83643H6.52389C6.14636 7.83643 5.84033 8.14246 5.84033 8.51998C5.84033 8.89751 6.14636 9.20354 6.52389 9.20354Z"
        fill="#3699FF"
      />
      <path
        d="M7.76509 1.7712L10.0688 3.31741C10.1857 3.39588 10.3181 3.43348 10.4491 3.43348C10.6693 3.43348 10.8854 3.32732 11.0173 3.1308C11.2277 2.81739 11.1441 2.39269 10.8307 2.18229L8.52699 0.636076C8.2135 0.425677 7.78888 0.509276 7.57848 0.822688C7.36808 1.1361 7.45161 1.5608 7.76509 1.7712Z"
        fill="#3699FF"
      />
      <path
        d="M10.0688 13.7225L7.76509 15.2687C7.45161 15.4791 7.36808 15.9038 7.57848 16.2172C7.7104 16.4138 7.92648 16.5199 8.14672 16.5199C8.27769 16.5199 8.4101 16.4823 8.52699 16.4038L10.8307 14.8576C11.1442 14.6472 11.2277 14.2225 11.0173 13.9091C10.8069 13.5957 10.3822 13.5121 10.0688 13.7225Z"
        fill="#3699FF"
      />
      <path
        d="M25.8018 4.73289C25.9351 4.86613 26.1093 4.93264 26.2837 4.93264C26.4587 4.93264 26.6339 4.86565 26.7676 4.73194C27.0345 4.46499 27.0336 4.03118 26.7666 3.76417C26.4997 3.49723 26.0668 3.49723 25.7998 3.76417C25.5329 4.03112 25.5329 4.46397 25.7998 4.73098L25.8018 4.73289Z"
        fill="#3699FF"
      />
    </svg>
  );
};
export const HelpIconCollapsed = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6583 12.4264L11.0699 13.7559C10.8457 13.5301 10.5353 13.39 10.1928 13.39H8.40913C8.32979 13.39 8.30075 13.3851 8.29203 13.383C8.27586 13.3721 8.23554 13.3341 8.20284 13.3033L8.18579 13.2873C6.73398 11.9201 5.50719 12.0068 4.11198 12.5575C3.89363 12.6436 3.88949 12.6438 3.67307 12.6537L3.28015 12.6542C3.1575 12.3065 2.82613 12.0566 2.43743 12.0566H1.12504C0.632312 12.0566 0.231445 12.458 0.231445 12.9513V16.3931C0.231445 16.8859 0.632312 17.2868 1.12504 17.2868H2.43739C2.82613 17.2868 3.1575 17.0372 3.28015 16.6899H4.00184C4.08354 16.6969 4.1632 16.7136 4.24086 16.7397L7.63457 17.6472C7.78317 17.6875 7.9196 17.7271 8.05157 17.7655C8.48984 17.8929 8.85826 17.9999 9.2424 17.9999C9.67638 17.9999 10.1304 17.8632 10.7277 17.4648C10.7307 17.4628 10.7336 17.4608 10.7365 17.4587L14.9209 14.479C15.4709 14.0866 15.6313 13.3783 15.2937 12.8311C14.9601 12.2917 14.2568 12.1178 13.6583 12.4264ZM2.62789 16.3932C2.62789 16.4964 2.54064 16.5837 2.43739 16.5837H1.12504C1.02175 16.5837 0.934536 16.4964 0.934536 16.3932V12.9513C0.934536 12.8475 1.02179 12.7598 1.12504 12.7598H2.43739C2.54068 12.7598 2.62789 12.8475 2.62789 12.9513V16.3932ZM14.5128 13.9065L10.3331 16.8829C9.48233 17.4491 9.12027 17.3439 8.24766 17.0903C8.11274 17.0511 7.97321 17.0106 7.81734 16.9683L4.42271 16.0606C4.28613 16.0182 4.1458 15.9936 4.00177 15.9868H3.33099V13.3576L3.70507 13.3561C3.97263 13.3439 4.05559 13.3356 4.37001 13.2115C5.57933 12.7342 6.51254 12.6774 7.70407 13.7994L7.72091 13.8152C7.92607 14.0084 8.05319 14.093 8.40913 14.093H10.1928C10.4869 14.093 10.7261 14.3323 10.7261 14.6264C10.7261 14.9199 10.4869 15.1587 10.1928 15.1587H7.30109C7.10693 15.1587 6.94955 15.3161 6.94955 15.5103C6.94955 15.7044 7.10693 15.8618 7.30109 15.8618H10.1928C10.8746 15.8618 11.4292 15.3076 11.4292 14.6264C11.4292 14.5402 11.4203 14.4561 11.4034 14.3749L13.98 13.0515C14.2148 12.9304 14.5361 12.9429 14.6955 13.2006C14.836 13.4285 14.7574 13.732 14.5128 13.9065Z"
        fill="#3699FF"
      />
      <path
        d="M8.32349 8.31506C7.94294 8.50043 7.68002 8.89114 7.68002 9.34214C7.68002 9.8394 8.00021 10.2631 8.4453 10.4189V10.9425C8.4453 11.5836 8.96643 12.1052 9.60695 12.1052H11.1644C11.8055 12.1052 12.3271 11.5836 12.3271 10.9425V10.4189C12.7722 10.2631 13.0923 9.83936 13.0923 9.34214C13.0923 8.8911 12.8294 8.50039 12.4488 8.31503C12.6028 7.74313 12.9148 7.3173 13.2431 6.87063C13.7479 6.1835 14.3202 5.40469 14.319 4.03285C14.319 3.91037 14.3139 3.78466 14.3039 3.65919C14.2885 3.46563 14.1195 3.32168 13.9256 3.33662C13.7321 3.35201 13.5876 3.52139 13.603 3.71495C13.6115 3.82192 13.6159 3.92886 13.6159 4.03313C13.6169 5.17439 13.1601 5.7961 12.6764 6.4543C12.3095 6.95374 11.9318 7.46857 11.7518 8.20032H9.02039C8.84044 7.46864 8.46267 6.95384 8.09562 6.45444C7.61182 5.79624 7.15488 5.17453 7.15639 4.03324C7.15794 2.81629 7.67932 2.04775 8.11646 1.61731C8.71838 1.02461 9.54286 0.691484 10.3812 0.703296C10.3845 0.703331 10.3879 0.703331 10.3912 0.703296C11.0743 0.692925 11.7593 0.915559 12.3185 1.32901C12.4746 1.44442 12.6948 1.41141 12.8102 1.25533C12.9256 1.09921 12.8926 0.879068 12.7365 0.763656C12.0556 0.260313 11.2211 -0.0104819 10.3861 0.000310578C9.3635 -0.0121693 8.35699 0.393901 7.62321 1.11647C6.85937 1.86863 6.45485 2.87697 6.45337 4.03243C6.45155 5.40483 7.02407 6.18375 7.52917 6.87095C7.85741 7.31752 8.16955 7.74327 8.32349 8.31506ZM11.624 10.9425C11.624 11.1959 11.4179 11.4021 11.1644 11.4021H9.60698C9.35411 11.4021 9.14843 11.1959 9.14843 10.9425V10.4829H11.624V10.9425ZM8.82177 8.90348H11.9506C12.1925 8.90348 12.3893 9.10027 12.3893 9.34214C12.3893 9.58347 12.1925 9.77981 11.9506 9.77981H8.82177C8.57991 9.77981 8.38311 9.58347 8.38311 9.34214C8.38311 9.10027 8.57991 8.90348 8.82177 8.90348Z"
        fill="#3699FF"
      />
      <path
        d="M10.7375 2.5681C10.7375 2.37394 10.5801 2.21655 10.386 2.21655C10.1918 2.21655 10.0344 2.37394 10.0344 2.5681V4.74842C10.0344 4.94258 10.1918 5.09996 10.386 5.09996C10.5801 5.09996 10.7375 4.94258 10.7375 4.74842V2.5681Z"
        fill="#3699FF"
      />
      <path
        d="M10.386 5.98706C10.1918 5.98706 10.0344 6.14445 10.0344 6.33862V6.34063C10.0344 6.53479 10.1918 6.6912 10.386 6.6912C10.5802 6.6912 10.7376 6.53283 10.7376 6.33866C10.7376 6.14449 10.5802 5.98706 10.386 5.98706Z"
        fill="#3699FF"
      />
      <path
        d="M17.4171 4.03003H15.9892C15.7951 4.03003 15.6377 4.18742 15.6377 4.38157C15.6377 4.57573 15.7951 4.73312 15.9892 4.73312H17.4171C17.6113 4.73312 17.7687 4.57573 17.7687 4.38157C17.7687 4.18742 17.6113 4.03003 17.4171 4.03003Z"
        fill="#3699FF"
      />
      <path
        d="M15.3986 1.76568C15.4659 1.76568 15.534 1.74635 15.5941 1.70599L16.7789 0.910797C16.9401 0.802591 16.9831 0.584211 16.8749 0.422992C16.7667 0.261809 16.5483 0.218815 16.3871 0.32702L15.2023 1.12222C15.0411 1.23042 14.9981 1.44884 15.1063 1.61002C15.1742 1.71109 15.2853 1.76568 15.3986 1.76568Z"
        fill="#3699FF"
      />
      <path
        d="M16.7791 7.85244L15.5944 7.05725C15.4331 6.94904 15.2147 6.99203 15.1066 7.15322C14.9984 7.3144 15.0413 7.53282 15.2025 7.64102L16.3873 8.43622C16.4474 8.47657 16.5155 8.49591 16.5829 8.49591C16.6961 8.49591 16.8073 8.44131 16.8751 8.34025C16.9833 8.17903 16.9404 7.96061 16.7791 7.85244Z"
        fill="#3699FF"
      />
      <path
        d="M3.35496 4.73312H4.78189C4.97605 4.73312 5.13343 4.57573 5.13343 4.38157C5.13343 4.18742 4.97605 4.03003 4.78189 4.03003H3.35496C3.1608 4.03003 3.00342 4.18742 3.00342 4.38157C3.00342 4.57573 3.1608 4.73312 3.35496 4.73312Z"
        fill="#3699FF"
      />
      <path
        d="M3.99331 0.910796L5.17809 1.70599C5.23821 1.74635 5.3063 1.76568 5.37366 1.76568C5.48689 1.76568 5.59805 1.71109 5.6659 1.61002C5.7741 1.44884 5.73111 1.23042 5.56992 1.12222L4.38515 0.32702C4.22393 0.218815 4.00555 0.261809 3.89734 0.422992C3.78914 0.584176 3.8321 0.802591 3.99331 0.910796Z"
        fill="#3699FF"
      />
      <path
        d="M5.17809 7.05725L3.99331 7.85244C3.8321 7.96065 3.78914 8.17906 3.89734 8.34025C3.96519 8.44131 4.07631 8.49591 4.18958 8.49591C4.25694 8.49591 4.32503 8.47657 4.38515 8.43622L5.56992 7.64102C5.73114 7.53282 5.7741 7.3144 5.6659 7.15322C5.55769 6.99203 5.33928 6.94904 5.17809 7.05725Z"
        fill="#3699FF"
      />
      <path
        d="M13.2693 2.43393C13.3378 2.50245 13.4274 2.53665 13.5171 2.53665C13.6071 2.53665 13.6972 2.5022 13.766 2.43343C13.9032 2.29615 13.9027 2.07305 13.7655 1.93573C13.6282 1.79844 13.4056 1.79844 13.2682 1.93573C13.131 2.07301 13.131 2.29562 13.2682 2.43294L13.2693 2.43393Z"
        fill="#3699FF"
      />
    </svg>
  );
};
export const FaqButtonCollapsed = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
        stroke="#3699FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.81738 6.75018C6.99371 6.24893 7.34175 5.82626 7.79985 5.55703C8.25795 5.2878 8.79655 5.18939 9.32027 5.27922C9.84398 5.36905 10.319 5.64133 10.6612 6.04783C11.0034 6.45433 11.1907 6.96882 11.1899 7.50018C11.1899 9.00018 8.93988 9.75018 8.93988 9.75018"
        stroke="#3699FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12.75H9.00875"
        stroke="#3699FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const IdCardIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M19.4791 19.25H2.52089C1.13028 19.25 0 18.1197 0 16.7291V5.27089C0 3.88028 1.13028 2.75 2.52089 2.75H19.4791C20.8697 2.75 22 3.88028 22 5.27089V16.7291C22 18.1197 20.8697 19.25 19.4791 19.25ZM2.52089 4.125C1.88928 4.125 1.375 4.63928 1.375 5.27089V16.7291C1.375 17.3607 1.88928 17.875 2.52089 17.875H19.4791C20.1107 17.875 20.625 17.3607 20.625 16.7291V5.27089C20.625 4.63928 20.1107 4.125 19.4791 4.125H2.52089Z"
          fill="#3699FF"
        />
        <path
          d="M6.87511 11C5.61189 11 4.5835 9.97145 4.5835 8.70841C4.5835 7.44519 5.61189 6.41663 6.87511 6.41663C8.13832 6.41663 9.16672 7.44519 9.16672 8.70841C9.16672 9.97145 8.13832 11 6.87511 11ZM6.87511 7.79163C6.37006 7.79163 5.9585 8.20319 5.9585 8.70841C5.9585 9.21346 6.37006 9.62502 6.87511 9.62502C7.38016 9.62502 7.79172 9.21346 7.79172 8.70841C7.79172 8.20319 7.38016 7.79163 6.87511 7.79163Z"
          fill="#3699FF"
        />
        <path
          d="M10.3125 15.5834C9.933 15.5834 9.625 15.2754 9.625 14.8959V14.4375C9.625 13.8059 9.11072 13.2916 8.47911 13.2916H5.27089C4.63928 13.2916 4.125 13.8059 4.125 14.4375V14.8959C4.125 15.2754 3.817 15.5834 3.4375 15.5834C3.058 15.5834 2.75 15.2754 2.75 14.8959V14.4375C2.75 13.0469 3.88028 11.9166 5.27089 11.9166H8.47911C9.86972 11.9166 11 13.0469 11 14.4375V14.8959C11 15.2754 10.692 15.5834 10.3125 15.5834Z"
          fill="#3699FF"
        />
        <path
          d="M18.5626 8.25H13.521C13.1415 8.25 12.8335 7.942 12.8335 7.5625C12.8335 7.183 13.1415 6.875 13.521 6.875H18.5626C18.9421 6.875 19.2501 7.183 19.2501 7.5625C19.2501 7.942 18.9421 8.25 18.5626 8.25Z"
          fill="#3699FF"
        />
        <path
          d="M18.5626 11.9166H13.521C13.1415 11.9166 12.8335 11.6086 12.8335 11.2291C12.8335 10.8496 13.1415 10.5416 13.521 10.5416H18.5626C18.9421 10.5416 19.2501 10.8496 19.2501 11.2291C19.2501 11.6086 18.9421 11.9166 18.5626 11.9166Z"
          fill="#3699FF"
        />
        <path
          d="M18.5626 15.5834H13.521C13.1415 15.5834 12.8335 15.2754 12.8335 14.8959C12.8335 14.5164 13.1415 14.2084 13.521 14.2084H18.5626C18.9421 14.2084 19.2501 14.5164 19.2501 14.8959C19.2501 15.2754 18.9421 15.5834 18.5626 15.5834Z"
          fill="#3699FF"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const LockIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1445 8.42188V6.14453C17.1445 2.7564 14.3881 0 11 0C7.61187 0 4.85547 2.7564 4.85547 6.14453V8.42188H2.83594V13.8359C2.83594 18.3376 6.49829 22 11 22C15.5017 22 19.1641 18.3376 19.1641 13.8359V8.42188H17.1445ZM6.14453 6.14453C6.14453 3.46719 8.32266 1.28906 11 1.28906C13.6773 1.28906 15.8555 3.46719 15.8555 6.14453V8.42188H6.14453V6.14453ZM17.875 13.8359C17.875 17.6268 14.7909 20.7109 11 20.7109C7.20908 20.7109 4.125 17.6268 4.125 13.8359V9.71094H17.875V13.8359Z"
        fill="#3699FF"
      />
      <path
        d="M10.3555 16.0669V18.0755H11.6445V16.0669C12.6354 15.7857 13.3633 14.8727 13.3633 13.793C13.3633 12.4899 12.3031 11.4297 11 11.4297C9.69689 11.4297 8.63672 12.4899 8.63672 13.793C8.63672 14.8727 9.36461 15.7857 10.3555 16.0669ZM11 12.7187C11.5923 12.7187 12.0742 13.2006 12.0742 13.793C12.0742 14.3853 11.5923 14.8672 11 14.8672C10.4077 14.8672 9.92578 14.3853 9.92578 13.793C9.92578 13.2006 10.4077 12.7187 11 12.7187Z"
        fill="#3699FF"
      />
    </svg>
  );
};
export const PhoneIcon = () => {
  return (
    <div className="position-relative">
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.125 0.34375H6.875C6.41932 0.344262 5.98244 0.525508 5.66023 0.847725C5.33801 1.16994 5.15676 1.60682 5.15625 2.0625V19.9375C5.15676 20.3932 5.33801 20.8301 5.66023 21.1523C5.98244 21.4745 6.41932 21.6557 6.875 21.6562H15.125C15.5807 21.6557 16.0176 21.4745 16.3398 21.1523C16.662 20.8301 16.8432 20.3932 16.8438 19.9375V2.0625C16.8432 1.60682 16.662 1.16994 16.3398 0.847725C16.0176 0.525508 15.5807 0.344262 15.125 0.34375ZM13.3307 1.03125L13.1245 2.0625H8.87558L8.66933 1.03125H13.3307ZM16.1562 19.9375C16.1559 20.2109 16.0472 20.473 15.8539 20.6664C15.6605 20.8597 15.3984 20.9684 15.125 20.9688H6.875C6.60159 20.9684 6.33947 20.8597 6.14613 20.6664C5.9528 20.473 5.84406 20.2109 5.84375 19.9375V2.0625C5.84406 1.78909 5.9528 1.52697 6.14613 1.33364C6.33947 1.1403 6.60159 1.03156 6.875 1.03125H7.96817L8.25666 2.47367C8.27225 2.55159 8.31435 2.62171 8.37581 2.67209C8.43727 2.72247 8.51428 2.75 8.59375 2.75H13.4062C13.4857 2.75 13.5627 2.72247 13.6242 2.67209C13.6856 2.62171 13.7278 2.55159 13.7433 2.47367L14.0318 1.03125H15.125C15.3984 1.03156 15.6605 1.1403 15.8539 1.33364C16.0472 1.52697 16.1559 1.78909 16.1562 2.0625V19.9375Z"
          fill="#3699FF"
        />
        <path
          d="M8.9375 19.5938H6.875C6.78383 19.5938 6.6964 19.63 6.63193 19.6944C6.56747 19.7589 6.53125 19.8463 6.53125 19.9375C6.53125 20.0287 6.56747 20.1161 6.63193 20.1806C6.6964 20.245 6.78383 20.2812 6.875 20.2812H8.9375C9.02867 20.2812 9.1161 20.245 9.18057 20.1806C9.24503 20.1161 9.28125 20.0287 9.28125 19.9375C9.28125 19.8463 9.24503 19.7589 9.18057 19.6944C9.1161 19.63 9.02867 19.5938 8.9375 19.5938Z"
          fill="#3699FF"
        />
        <path
          d="M10.3125 19.5938H9.96875C9.87758 19.5938 9.79015 19.63 9.72568 19.6944C9.66122 19.7589 9.625 19.8463 9.625 19.9375C9.625 20.0287 9.66122 20.1161 9.72568 20.1806C9.79015 20.245 9.87758 20.2812 9.96875 20.2812H10.3125C10.4037 20.2812 10.4911 20.245 10.5556 20.1806C10.62 20.1161 10.6562 20.0287 10.6562 19.9375C10.6562 19.8463 10.62 19.7589 10.5556 19.6944C10.4911 19.63 10.4037 19.5938 10.3125 19.5938Z"
          fill="#3699FF"
        />
      </svg>
      <div style={{ position: "absolute", top: -15, right: -15 }}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8" r="8" fill="#FF4B55" />
          <path d="M6.11 6.53V4.93H8.97V12H7.17V6.53H6.11Z" fill="white" />
        </svg>
      </div>
    </div>
  );
};
export const EnvelopeIcon = () => {
  return (
    <div className="position-relative">
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0)">
          <path
            d="M19.9375 2.75H2.06251C0.925174 2.75 0 3.67517 0 4.81251V17.1875C0 18.3248 0.925174 19.25 2.06251 19.25H19.9375C21.0748 19.25 22 18.3248 22 17.1875V4.81251C22 3.67517 21.0748 2.75 19.9375 2.75ZM19.9375 4.12499C20.0309 4.12499 20.1198 4.14437 20.201 4.17822L11 12.1528L1.79896 4.17822C1.8802 4.14442 1.96906 4.12499 2.06247 4.12499H19.9375ZM19.9375 17.875H2.06251C1.68319 17.875 1.37499 17.5668 1.37499 17.1875V5.63092L10.5495 13.5821C10.6791 13.6942 10.8395 13.75 11 13.75C11.1605 13.75 11.3209 13.6943 11.4505 13.5821L20.625 5.63092V17.1875C20.625 17.5668 20.3168 17.875 19.9375 17.875Z"
            fill="#3699FF"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="22" height="22" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <div style={{ position: "absolute", top: -15, right: -15 }}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8" r="8" fill="#FF4B55" />
          <path d="M6.11 6.53V4.93H8.97V12H7.17V6.53H6.11Z" fill="white" />
        </svg>
      </div>
    </div>
  );
};
export const ButtonArrowIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="ml-2"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.3"
        x="4.16663"
        y="10.8333"
        width="1.66667"
        height="11.6667"
        rx="0.833333"
        transform="rotate(-90 4.16663 10.8333)"
        fill="white"
      />
      <path
        d="M9.41078 14.4107C9.08535 14.7361 9.08535 15.2637 9.41078 15.5892C9.73622 15.9146 10.2639 15.9146 10.5893 15.5892L15.5893 10.5892C15.9048 10.2737 15.9158 9.7657 15.6143 9.43681L11.031 4.43681C10.72 4.09755 10.1929 4.07463 9.8536 4.38562C9.51434 4.69662 9.49142 5.22376 9.80241 5.56302L13.8466 9.97486L9.41078 14.4107Z"
        fill="white"
      />
    </svg>
  );
};
export const ButtonBackIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="mr-2 rotate180"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.3"
        x="4.16663"
        y="10.8333"
        width="1.66667"
        height="11.6667"
        rx="0.833333"
        transform="rotate(-90 4.16663 10.8333)"
        fill="white"
      />
      <path
        d="M9.41078 14.4107C9.08535 14.7361 9.08535 15.2637 9.41078 15.5892C9.73622 15.9146 10.2639 15.9146 10.5893 15.5892L15.5893 10.5892C15.9048 10.2737 15.9158 9.7657 15.6143 9.43681L11.031 4.43681C10.72 4.09755 10.1929 4.07463 9.8536 4.38562C9.51434 4.69662 9.49142 5.22376 9.80241 5.56302L13.8466 9.97486L9.41078 14.4107Z"
        fill="white"
      />
    </svg>
  );
};
export const QuestionMark = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 20.1667C16.0626 20.1667 20.1666 16.0627 20.1666 11C20.1666 5.93743 16.0626 1.83337 11 1.83337C5.93737 1.83337 1.83331 5.93743 1.83331 11C1.83331 16.0627 5.93737 20.1667 11 20.1667Z"
        stroke="#3699FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 14.6667V11"
        stroke="#3699FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 7.33337H11.01"
        stroke="#3699FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BackIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 12H5"
        stroke="#80808F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 19L5 12L12 5"
        stroke="#80808F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PlusIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5V19"
        stroke="#3699FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 12H19"
        stroke="#3699FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const MinusIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 12H19"
        stroke="#3699FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DropdownArrowIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 7.5L10 12.5L15 7.5"
        stroke="#80808F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TooltipArrowIcon = () => {
  return (
    <svg
      width="9"
      height="4"
      viewBox="0 0 9 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="5.0025"
        height="5.0015"
        transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 8.03662 0.000732422)"
        fill="black"
        fillOpacity="0.75"
      />
    </svg>
  );
};
export const CheckIconLanguageDropdown = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6666 3.5L5.24998 9.91667L2.33331 7"
        stroke="#4CAF50"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const RetryIcon = ({ isPassive }) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2915 2.83337V7.08337H12.0415"
        stroke={isPassive ? "#80808F" : "#3699FF"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5138 10.625C14.0534 11.9282 13.1818 13.0466 12.0305 13.8114C10.8792 14.5763 9.51049 14.9462 8.13063 14.8655C6.75077 14.7847 5.43452 14.2577 4.38024 13.3639C3.32595 12.47 2.59075 11.2577 2.28542 9.90959C1.98009 8.56152 2.12117 7.15073 2.6874 5.88981C3.25363 4.62889 4.21433 3.58616 5.42474 2.91876C6.63516 2.25135 8.02969 1.99542 9.39822 2.18953C10.7667 2.38364 12.0351 3.01728 13.0122 3.99497L16.2917 7.0833"
        stroke={isPassive ? "#80808F" : "#3699FF"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SelectArrowIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9L12 15L18 9"
        stroke="#80808F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CallIcon = () => {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3153 5.81528C13.3153 2.60359 10.7117 0 7.49997 0C4.28828 0 1.68469 2.60359 1.68469 5.81528C0.854399 5.91866 0.0693359 6.46142 0.0693359 7.7214V10.7583C0.0693359 12.1798 1.0644 12.6967 2.00776 12.6967H2.94467C3.12308 12.6967 3.26774 12.552 3.26774 12.3736V6.11897C3.26774 5.94055 3.12308 5.7959 2.94467 5.7959H2.33083C2.33083 2.94108 4.64515 0.626758 7.49997 0.626758C10.3548 0.626758 12.6691 2.94108 12.6691 5.7959H12.0553C11.8769 5.7959 11.7322 5.94055 11.7322 6.11897V12.3639C11.7322 12.5423 11.8769 12.687 12.0553 12.687H12.6691C12.5786 14.9065 11.5125 15.4266 9.38348 15.5203V15.3039C9.38348 14.947 9.09421 14.6577 8.73733 14.6577H6.70522C6.34834 14.6577 6.05907 14.947 6.05907 15.3039V16.3539C6.05907 16.7107 6.34834 17 6.70522 17H8.74379C9.10067 17 9.38994 16.7107 9.38994 16.3539V16.1665C11.4382 16.0728 13.2086 15.6496 13.3153 12.6676C14.1455 12.5642 14.9306 12.0215 14.9306 10.7615V7.72463C14.9306 6.45819 14.1488 5.91866 13.3153 5.81528ZM2.6216 6.41942V12.0409H1.99161C1.51346 12.0409 0.699325 11.8729 0.699325 10.7486V7.71171C0.699325 6.59711 1.50377 6.41942 1.99161 6.41942H2.6216ZM8.74379 15.866V16.3571H6.70522V15.3071H8.74379V15.866ZM14.2845 10.7583C14.2845 11.8729 13.48 12.0506 12.9922 12.0506H12.3783V6.44204H13.0083C13.4865 6.44204 14.3006 6.61003 14.3006 7.73432L14.2845 10.7583Z"
        fill="#FFA800"
      />
    </svg>
  );
};
export const FaqIconDashboard = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.50016 17.4163C13.8724 17.4163 17.4168 13.8719 17.4168 9.49968C17.4168 5.12742 13.8724 1.58301 9.50016 1.58301C5.12791 1.58301 1.5835 5.12742 1.5835 9.49968C1.5835 13.8719 5.12791 17.4163 9.50016 17.4163Z"
        stroke="#B5B5C3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.19629 7.12496C7.38241 6.59587 7.74978 6.14971 8.23334 5.86553C8.71689 5.58134 9.28541 5.47746 9.83822 5.57228C10.391 5.6671 10.8924 5.9545 11.2536 6.38359C11.6148 6.81268 11.8125 7.35575 11.8117 7.91663C11.8117 9.49996 9.43671 10.2916 9.43671 10.2916"
        stroke="#B5B5C3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 13.458H9.50875"
        stroke="#B5B5C3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const OverviewCarrierRegisterIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      viewBox="0 0 178.968 178.968"
    >
      <path
        fill={
          props.step === 3 ? "#3699FF" : props.step > 3 ? "#00C233" : "#B5B5C3"
        }
        d="M94.636,68.021H24.139v-5.742h70.497V68.021z M24.139,93.603h54.303v-5.779H24.139V93.603z M24.139,113.393v5.76h54.303
		v-5.76H24.139z M24.139,144.715h70.497v-5.761H24.139V144.715z M119.157,160.784l8.189-8.19c-2.782-0.134-5.528-0.512-8.189-1.15
		V160.784z M10.682,139.575V25.376c0-17.25,1.392-18.647,18.639-18.647h88.832c17.263,0,18.646,1.403,18.646,18.647v37.22
		c2.302,0.38,4.542,0.947,6.734,1.666V25.376C143.532,4.433,139.087,0,118.152,0H29.327C8.396,0,3.957,4.433,3.957,25.376v114.199
		c0,20.935,4.439,25.38,25.371,25.38h85.659v-6.734H29.327C12.073,158.221,10.682,156.832,10.682,139.575z M149.122,141.262
		c-18.706,10.784-42.722,4.379-53.521-14.352c-10.793-18.693-4.357-42.709,14.349-53.509c18.706-10.787,42.722-4.369,53.523,14.343
		C174.282,106.444,167.84,130.466,149.122,141.262z M145.889,135.654c15.618-9.024,20.977-29.046,11.978-44.661
		c-9.013-15.613-29.046-20.978-44.658-11.978c-15.625,9.009-20.998,29.03-11.959,44.654
		C110.249,139.271,130.276,144.684,145.889,135.654z M158.975,138.832l-16.843,9.743l12.97,22.444l16.843-9.742L158.975,138.832z
		 M173.704,164.358l-16.849,9.736c2.691,4.664,8.646,6.254,13.299,3.568C174.806,174.978,176.389,169.022,173.704,164.358z"
      />
    </svg>
  );
};
export const SecurityIconRegister = props => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="22" height="22" fill="#B5B5C3" fillOpacity="0.08" />
      <path
        d="M11 22C10.9855 22 10.9711 21.9994 10.9568 21.9981C10.7606 21.9813 6.11732 21.5192 3.17871 15.6881C0.285242 9.94711 2.10948 1.56839 2.18862 1.21447C2.23426 1.01013 2.40105 0.855087 2.60812 0.824422C2.6402 0.819564 5.84164 0.345618 8.11765 0.173871C10.3946 0.00202412 10.9764 0 11 0C11.0236 0 11.6055 0.00202412 13.8824 0.173871C16.1584 0.345516 19.3599 0.819564 19.392 0.824422C19.599 0.855188 19.7657 1.01024 19.8115 1.21447C19.8905 1.56839 21.7148 9.94711 18.8214 15.6882C15.8828 21.5192 11.2394 21.9814 11.0433 21.9982C11.0289 21.9994 11.0145 22 11 22ZM3.10838 1.77454C2.80192 3.39373 1.66802 10.4419 4.08248 15.2328C6.62224 20.2722 10.5416 20.9252 10.9995 20.9847C11.212 20.9567 12.1952 20.7968 13.4251 20.1231C14.7029 19.4233 16.5198 18.0067 17.9177 15.2328C20.3347 10.4367 19.199 3.39343 18.8919 1.77454C18.0024 1.64793 15.6054 1.31871 13.8063 1.18289C11.5912 1.0158 11.0049 1.01206 10.9992 1.01206C10.9952 1.01206 10.4089 1.0158 8.19376 1.18289C6.39493 1.31871 3.99797 1.64793 3.10838 1.77454ZM11 19.9402C10.9853 19.9402 10.9706 19.9396 10.9561 19.9382C10.796 19.9243 7.00935 19.5416 4.62373 14.7335C2.28466 10.0194 3.757 3.15043 3.82076 2.86038C3.8658 2.65574 4.03228 2.49998 4.23945 2.46871C4.26526 2.46487 6.84216 2.07745 8.6752 1.93688C10.5092 1.7962 10.9808 1.79468 11 1.79468C11.0192 1.79468 11.4907 1.7963 13.3248 1.93688C15.1578 2.07745 17.7347 2.46487 17.7605 2.46871C17.9677 2.50009 18.1342 2.65574 18.1792 2.86038C18.243 3.15043 19.7154 10.0194 17.3763 14.7336C14.9906 19.5417 11.2039 19.9244 11.0439 19.9383C11.0293 19.9397 11.0147 19.9402 11 19.9402ZM4.74305 3.41782C4.48234 4.84684 3.63222 10.4581 5.53043 14.2837C7.53451 18.3228 10.6028 18.8702 11.0011 18.9248C11.423 18.8698 14.4578 18.3386 16.4698 14.2837C18.3705 10.4528 17.5186 4.84563 17.2572 3.41782C16.494 3.30821 14.645 3.05307 13.2475 2.9459C11.4759 2.81008 11.0036 2.80664 10.999 2.80664C10.9966 2.80664 10.5243 2.81008 8.75272 2.9459C7.35466 3.05307 5.50624 3.30821 4.74305 3.41782ZM10.8672 16.0793C10.5878 16.0793 10.3612 15.8528 10.3612 15.5732V15.472C10.3612 15.1925 10.5878 14.966 10.8672 14.966C11.1466 14.966 11.3732 15.1925 11.3732 15.472V15.5732C11.3732 15.8528 11.1466 16.0793 10.8672 16.0793ZM10.8735 14.3397C10.5941 14.3397 10.3675 14.1132 10.3675 13.8337V12.9329C10.3675 12.231 10.6407 11.5714 11.137 11.0751L12.2981 9.91411C12.6032 9.60898 12.7712 9.20345 12.7712 8.77191V6.96862C12.7712 5.99209 11.9766 5.19752 11.0001 5.19752C10.0236 5.19752 9.22899 5.99209 9.22899 6.96862V7.55896C9.22899 7.83849 9.00239 8.06498 8.72297 8.06498C8.44354 8.06498 8.21694 7.83849 8.21694 7.55896V6.96862C8.21694 5.43404 9.46541 4.18546 11.0001 4.18546C12.5348 4.18546 13.7833 5.43404 13.7833 6.96862V8.7718C13.7833 9.47367 13.51 10.1333 13.0137 10.6295L11.8527 11.7906C11.5475 12.0957 11.3795 12.5012 11.3795 12.9328V13.8336C11.3795 14.1132 11.153 14.3397 10.8735 14.3397Z"
        fill={
          props.step === 3 ? "#3699FF" : props.step > 3 ? "#00C233" : "#B5B5C3"
        }
      />
    </svg>
  );
};
export const RegistrantCarrierRegisterIcon = props => {
  return (
    <svg
      height="22"
      viewBox="0 0 512 512"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        fill={
          props.step === 2 ? "#3699FF" : props.step > 2 ? "#00C233" : "#B5B5C3"
        }
      >
        <path d="m378.575 0h-300.585c-13.862 0-25.138 11.277-25.138 25.139v9.57h-12.346c-13.861 0-25.138 11.277-25.138 25.139v321.316c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-321.316c0-5.591 4.548-10.139 10.138-10.139h300.585c5.59 0 10.138 4.548 10.138 10.139v427.014c0 5.591-4.548 10.139-10.138 10.139h-300.585c-5.59 0-10.138-4.548-10.138-10.139v-70.697c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v70.697c0 13.861 11.277 25.139 25.138 25.139h300.585c13.861 0 25.138-11.277 25.138-25.139v-9.57h12.345c13.861 0 25.138-11.277 25.138-25.139v-331.664c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v331.663c0 5.591-4.548 10.139-10.138 10.139h-9.571v-402.443c0-13.861-11.277-25.139-25.138-25.139-4.13 0-274.112 0-276.014 0v-9.57c.001-5.591 4.548-10.139 10.139-10.139h300.585c5.59 0 10.138 4.548 10.138 10.139v60.351c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-60.351c0-13.862-11.277-25.139-25.138-25.139z" />
        <path d="m479.717 148.796h-40.013c-9.327 0-16.915 7.588-16.915 16.915v212.903c0 .145.014.286.022.429.004.078.005.156.012.234.053.6.178 1.178.363 1.729.02.058.043.116.064.174.084.23.179.455.284.675.017.035.028.073.046.108l24.61 49.306c2.398 4.805 6.705 7.674 11.522 7.674s9.124-2.869 11.521-7.673l24.61-49.307c.022-.043.035-.089.056-.132.097-.203.184-.411.263-.624.027-.073.055-.144.079-.217.086-.257.161-.52.219-.789.004-.019.011-.037.015-.056.058-.278.097-.563.123-.852.009-.098.01-.196.015-.294.007-.128.019-.255.019-.385 0-7.78 0-202.277 0-212.903 0-9.327-7.588-16.915-16.915-16.915zm-20.006 271.97-17.295-34.651h34.591zm21.921-49.652h-43.842v-160.382h43.842zm0-175.382h-43.842v-30.021c0-1.056.859-1.915 1.915-1.915h40.013c1.056 0 1.915.859 1.915 1.915v30.021z" />
        <path d="m58.218 456.258c0 8.547 6.953 15.5 15.5 15.5h41.333c8.547 0 15.5-6.953 15.5-15.5v-39.496l17.111-18.203c2.837-3.018 2.69-7.765-.328-10.602s-7.764-2.69-10.602.328l-12.987 13.816c-2.481-1.688-5.474-2.676-8.694-2.676h-41.333c-8.547 0-15.5 6.953-15.5 15.5zm57.333-23.539v23.539c0 .275-.224.5-.5.5h-22.227c.295-.231.58-.479.841-.756zm-42.333-17.794c0-.275.224-.5.5-.5h38.443l-22.91 24.372-13.441-20.483c-.681-1.038-1.579-1.847-2.591-2.416v-.973zm0 26.782c9.497 14.472 9.039 14.02 10.351 15.051h-9.851c-.276 0-.5-.225-.5-.5z" />
        <path d="m315.625 428.091h-159.333c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h159.333c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5z" />
        <path d="m75.718 242.911h132.959c9.649 0 17.5-7.851 17.5-17.5v-132.96c0-9.649-7.851-17.5-17.5-17.5h-132.959c-9.649 0-17.5 7.851-17.5 17.5v132.96c0 9.65 7.851 17.5 17.5 17.5zm-2.5-150.46c0-1.379 1.122-2.5 2.5-2.5h132.959c1.378 0 2.5 1.121 2.5 2.5v132.96c0 1.379-1.122 2.5-2.5 2.5h-132.959c-1.378 0-2.5-1.121-2.5-2.5z" />
        <path d="m113 215.89c4.14 0 7.51-3.36 7.51-7.49v-16.2c.02-11.909 9.699-21.627 21.596-21.698.031 0 .061.002.092.002.032 0 .063-.002.094-.002 11.898.07 21.578 9.788 21.598 21.698v8.699h-15.89c-4.13 0-7.5 3.36-7.5 7.5 0 4.13 3.37 7.5 7.5 7.5.01 0 .02 0 .02-.01h23.37c1.97 0 3.91-.8 5.3-2.189 1.4-1.4 2.2-3.33 2.2-5.301v-16.199c0-9.811-3.82-19.021-10.75-25.95-1.307-1.307-2.695-2.503-4.153-3.583 7.617-6.291 12.48-15.803 12.48-26.43 0-18.896-15.373-34.27-34.269-34.27s-34.269 15.373-34.269 34.27c0 10.626 4.862 20.138 12.478 26.429-1.459 1.081-2.849 2.277-4.157 3.585-6.93 6.93-10.74 16.14-10.74 25.95v16.199c0 1.971.8 3.9 2.19 5.301 1.4 1.389 3.33 2.189 5.3 2.189zm29.198-98.923c10.625 0 19.269 8.645 19.269 19.27 0 10.603-8.609 19.229-19.204 19.265-.021 0-.042-.001-.063-.001-.022 0-.044.001-.066.002-10.595-.035-19.205-8.662-19.205-19.265 0-10.627 8.644-19.271 19.269-19.271z" />
        <path d="m249.337 126.567h66.288c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-66.288c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5z" />
        <path d="m249.337 169.088h66.288c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-66.288c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5z" />
        <path d="m249.337 214.441h66.288c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-66.288c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5z" />
        <path d="m65.718 286.865h249.907c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-249.907c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5z" />
        <path d="m65.718 329.385h249.907c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-249.907c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5z" />
        <path d="m65.718 371.905h249.907c4.142 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5h-249.907c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5z" />
      </g>
    </svg>
  );
};
export const LockIconRegister = props => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8984 15.7266C15.3731 15.7266 15.7578 15.3418 15.7578 14.8672C15.7578 14.3926 15.3731 14.0078 14.8984 14.0078C14.4238 14.0078 14.0391 14.3926 14.0391 14.8672C14.0391 15.3418 14.4238 15.7266 14.8984 15.7266Z"
        fill={
          props.step === 2 ? "#3699FF" : props.step > 2 ? "#00C233" : "#B5B5C3"
        }
      />
      <path
        d="M18.7656 15.5547C19.2403 15.5547 19.625 15.1699 19.625 14.6953V11.5156C19.625 9.62019 18.0829 8.07812 16.1875 8.07812H15.1547V5.04737C15.1547 2.26424 12.8416 0 9.99841 0C7.15525 0 4.84216 2.26424 4.84216 5.04737V8.07812H3.8125C1.91706 8.07812 0.375 9.62019 0.375 11.5156V18.5625C0.375 20.4579 1.91706 22 3.8125 22H16.1875C18.0829 22 19.625 20.4579 19.625 18.5625C19.625 18.0879 19.2403 17.7031 18.7656 17.7031C18.291 17.7031 17.9062 18.0879 17.9062 18.5625C17.9062 19.5102 17.1352 20.2812 16.1875 20.2812H3.8125C2.86478 20.2812 2.09375 19.5102 2.09375 18.5625V11.5156C2.09375 10.5679 2.86478 9.79688 3.8125 9.79688H16.1875C17.1352 9.79688 17.9062 10.5679 17.9062 11.5156V14.6953C17.9062 15.1699 18.291 15.5547 18.7656 15.5547ZM13.4359 8.07812H6.56091V5.04737C6.56091 3.21196 8.10297 1.71875 9.99841 1.71875C11.8938 1.71875 13.4359 3.21196 13.4359 5.04737V8.07812Z"
        fill={
          props.step === 2 ? "#3699FF" : props.step > 2 ? "#00C233" : "#B5B5C3"
        }
      />
      <path
        d="M8.41016 15.7266C8.88478 15.7266 9.26953 15.3418 9.26953 14.8672C9.26953 14.3926 8.88478 14.0078 8.41016 14.0078C7.93554 14.0078 7.55078 14.3926 7.55078 14.8672C7.55078 15.3418 7.93554 15.7266 8.41016 15.7266Z"
        fill={
          props.step === 2 ? "#3699FF" : props.step > 2 ? "#00C233" : "#B5B5C3"
        }
      />
      <path
        d="M5.1875 15.7266C5.66212 15.7266 6.04688 15.3418 6.04688 14.8672C6.04688 14.3926 5.66212 14.0078 5.1875 14.0078C4.71288 14.0078 4.32812 14.3926 4.32812 14.8672C4.32812 15.3418 4.71288 15.7266 5.1875 15.7266Z"
        fill={
          props.step === 2 ? "#3699FF" : props.step > 2 ? "#00C233" : "#B5B5C3"
        }
      />
      <path
        d="M11.6328 15.7266C12.1074 15.7266 12.4922 15.3418 12.4922 14.8672C12.4922 14.3926 12.1074 14.0078 11.6328 14.0078C11.1582 14.0078 10.7734 14.3926 10.7734 14.8672C10.7734 15.3418 11.1582 15.7266 11.6328 15.7266Z"
        fill={
          props.step === 2 ? "#3699FF" : props.step > 2 ? "#00C233" : "#B5B5C3"
        }
      />
    </svg>
  );
};
export const CompanyRegisterCarrierIcon = props => {
  return (
    <svg
      id="_x31__px"
      height="20"
      viewBox="0 0 24 24"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="XMLID_1_"
        fill={
          props.step === 0 ? "#3699FF" : props.step > 0 ? "#00C233" : "#B5B5C3"
        }
      >
        <path d="m14 9.09 8.81 1.75c.71.15 1.19.75 1.19 1.46v10.2c0 .83-.67 1.5-1.5 1.5h-9c.28 0 .5-.22.5-.5v-.5h8.5c.27 0 .5-.22.5-.5v-10.2c0-.23-.16-.44-.39-.49l-8.61-1.7z" />
        <path d="m19.5 14c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z" />
        <path d="m19.5 17c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z" />
        <path d="m19.5 20c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z" />
        <path d="m14 23.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-.5-13.5c0-.15.07-.29.18-.39.12-.09.27-.13.42-.1l.4.08v1.02 12.89z" />
        <path d="m13 23v.5c0 .28.22.5.5.5h-4c.28 0 .5-.22.5-.5v-.5z" />
        <path d="m10.5 5c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z" />
        <path d="m11 8.5c0 .28-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h2c.28 0 .5.22.5.5z" />
        <path d="m10.5 11c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z" />
        <path d="m10.5 14c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z" />
        <path d="m6 14.5c0 .28-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h2c.28 0 .5.22.5.5z" />
        <path d="m5.5 5c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z" />
        <path d="m5.5 8c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z" />
        <path d="m5.5 11c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z" />
        <path d="m9 18.5c0-.28-.23-.5-.5-.5h-3c-.28 0-.5.22-.5.5v4.5h-1v-4.5c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5v4.5h-1z" />
        <path d="m5 23h4 1v.5c0 .28-.22.5-.5.5h-5c-.28 0-.5-.22-.5-.5v-.5z" />
        <path d="m1.75.2 10.99 1.67c.73.12 1.26.74 1.26 1.48v5.74l-.4-.08c-.15-.03-.3.01-.42.1-.11.1-.18.24-.18.39v-6.15c0-.25-.18-.46-.42-.5l-10.99-1.66c-.03-.01-.06-.01-.09-.01-.12 0-.23.04-.32.12-.12.1-.18.23-.18.38v20.82c0 .28.23.5.5.5h2.5v.5c0 .28.22.5.5.5h-3c-.83 0-1.5-.67-1.5-1.5v-20.82c0-.44.19-.86.53-1.14.34-.29.78-.41 1.22-.34z" />
      </g>
    </svg>
  );
};
export const PhoneVerificationRegister = props => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.4285 3.55925L15.7838 0.821449C15.3096 0.593371 14.7573 0.593371 14.283 0.821449L8.63814 3.55929C8.3398 3.70379 8.13321 3.9876 8.08741 4.31588H1.83335C0.821305 4.31704 0.00120312 5.13719 0 6.14919V17.5159C0.00120312 18.5279 0.821305 19.348 1.83335 19.3492H20.1667C21.1787 19.348 21.9988 18.5279 22 17.5159V4.46198C21.9999 4.07595 21.7774 3.7245 21.4285 3.55925ZM21.2667 17.5159C21.266 18.1231 20.7739 18.6152 20.1667 18.6159H1.83335C1.22611 18.6152 0.733992 18.1231 0.733348 17.5159V6.14919C0.733992 5.54195 1.22611 5.04983 1.83335 5.04919H8.0667V7.82316C8.10721 11.0039 9.61138 13.9885 12.1439 15.9134L14.3183 17.6351C14.7386 17.9631 15.3282 17.9631 15.7484 17.6351L17.9223 15.9138C19.399 14.7644 20.5515 13.2508 21.2667 11.5216V17.5159H21.2667ZM21.2667 7.82321C21.2253 10.7797 19.8238 13.5522 17.4675 15.3384L15.2933 17.0601C15.1403 17.179 14.9263 17.179 14.7733 17.0601L12.5984 15.3381C10.2426 13.5518 8.84134 10.7795 8.8 7.82321V4.46198C8.80155 4.35722 8.86312 4.26264 8.95825 4.21886L14.6033 1.48102C14.8751 1.35022 15.1917 1.35022 15.4636 1.48102L21.1084 4.21886C21.2036 4.2626 21.2652 4.35722 21.2667 4.46198V7.82321Z"
        fill={
          props.step === 1 ? "#3699FF" : props.step > 1 ? "#00C233" : "#B5B5C3"
        }
      />
      <path
        d="M15.0138 4.34522C12.9988 4.34793 11.3667 5.98216 11.3667 7.99718C11.373 10.0172 13.0133 11.651 15.0334 11.6492C17.0484 11.6411 18.6761 10.0024 18.6707 7.98742C18.6653 5.97245 17.0289 4.34255 15.0138 4.34522ZM15.0138 10.9159C13.4038 10.9132 12.1 9.6073 12.1 7.99726C12.106 6.38207 13.4182 5.07646 15.0334 5.07861C16.6434 5.08669 17.9428 6.39698 17.9374 8.00702C17.932 9.61701 16.6239 10.9186 15.0138 10.9159Z"
        fill={
          props.step === 1 ? "#3699FF" : props.step > 1 ? "#00C233" : "#B5B5C3"
        }
      />
      <path
        d="M15.9743 6.98986L14.4335 8.53064L14.0926 8.18977C13.9494 8.04711 13.7176 8.04732 13.5747 8.19028C13.4317 8.33324 13.4315 8.56497 13.5741 8.70823L14.1743 9.30837C14.243 9.37716 14.3362 9.41579 14.4335 9.41579C14.5307 9.41579 14.624 9.37716 14.6927 9.30837L16.4928 7.50832C16.6347 7.36494 16.6341 7.13381 16.4914 6.99115C16.3487 6.8485 16.1176 6.84794 15.9743 6.98986Z"
        fill={
          props.step === 1 ? "#3699FF" : props.step > 1 ? "#00C233" : "#B5B5C3"
        }
      />
      <path
        d="M8.06675 14.9492H2.28316C2.08064 14.9492 1.9165 15.1134 1.9165 15.3159C1.9165 15.5184 2.08064 15.6825 2.28316 15.6825H8.06675C8.26926 15.6825 8.4334 15.5184 8.4334 15.3159C8.4334 15.1134 8.26926 14.9492 8.06675 14.9492Z"
        fill={
          props.step === 1 ? "#3699FF" : props.step > 1 ? "#00C233" : "#B5B5C3"
        }
      />
      <path
        d="M5.13345 16.416H2.28316C2.08064 16.416 1.9165 16.5802 1.9165 16.7827C1.9165 16.9852 2.08064 17.1493 2.28316 17.1493H5.1334C5.33592 17.1493 5.50006 16.9852 5.50006 16.7827C5.50006 16.5802 5.33596 16.416 5.13345 16.416Z"
        fill={
          props.step === 1 ? "#3699FF" : props.step > 1 ? "#00C233" : "#B5B5C3"
        }
      />
      <path
        d="M7.63764 12.1773L7.63747 12.1769L6.36362 11.5492C6.32533 11.5309 6.30067 11.4925 6.2999 11.45V11.088C6.31674 11.0662 6.33401 11.0429 6.3518 11.0182C6.51427 10.7913 6.6464 10.5442 6.74497 10.2831C6.96608 10.1455 7.10036 9.90329 7.09998 9.64286V9.11722C7.09967 8.96494 7.05318 8.81636 6.9666 8.6911V8.08451C6.99573 7.71438 6.87645 7.34786 6.63501 7.06581C6.23953 6.67075 5.69034 6.46962 5.13325 6.51581C4.57603 6.46953 4.02672 6.67084 3.63132 7.0662C3.39001 7.34816 3.27077 7.71455 3.2999 8.08456V8.69115C3.21332 8.8164 3.16683 8.96498 3.16653 9.11727V9.6429C3.16649 9.84554 3.24804 10.0397 3.39285 10.1814C3.48879 10.5036 3.63764 10.8076 3.83328 11.0809V11.4379C3.83263 11.4789 3.80956 11.5163 3.77312 11.5353L2.58362 12.1748C2.12247 12.4209 1.83411 12.9007 1.83325 13.4234V13.8491C1.83321 13.9464 1.87184 14.0396 1.94063 14.1084C2.00938 14.1772 2.10267 14.2158 2.19995 14.2158H8.0666C8.16384 14.2159 8.25712 14.1772 8.32592 14.1084C8.39467 14.0397 8.4333 13.9464 8.4333 13.8491V13.4492C8.4339 12.9077 8.12482 12.4136 7.63764 12.1773ZM7.69995 13.4825H2.5666V13.4234C2.56763 13.1707 2.70767 12.9391 2.93093 12.8207L4.12082 12.1809C4.39488 12.0342 4.56615 11.7487 4.56662 11.4378V10.9573C4.56624 10.8709 4.53573 10.7873 4.48034 10.721C4.28913 10.4753 4.15103 10.1925 4.0748 9.89062C4.0479 9.78981 3.98586 9.70194 3.89988 9.64282L3.91028 9.09961C3.98852 9.03004 4.03329 8.93035 4.03329 8.82568V8.06548C4.03329 8.04919 4.03222 8.03291 4.03007 8.01679C4.01989 7.84698 4.07472 7.67966 4.18334 7.54878C4.44459 7.32117 4.78877 7.21259 5.1333 7.24907C5.47498 7.21384 5.8162 7.31993 6.07771 7.54268C6.1902 7.67412 6.24713 7.8441 6.23652 8.01679C6.23437 8.03295 6.2333 8.04919 6.2333 8.06548V8.82568C6.23699 8.93675 6.28503 9.04173 6.36667 9.11714L6.34269 9.66752C6.22844 9.70237 6.13833 9.79067 6.10117 9.9042C6.0221 10.1491 5.90583 10.3804 5.75634 10.5899C5.72631 10.6326 5.69404 10.6737 5.65966 10.7131C5.59968 10.7803 5.56655 10.8672 5.56655 10.9573V11.45C5.56586 11.7723 5.74977 12.0666 6.03976 12.2073L7.31344 12.835C7.54939 12.9486 7.69956 13.1872 7.69999 13.4491V13.4825H7.69995Z"
        fill={
          props.step === 1 ? "#3699FF" : props.step > 1 ? "#00C233" : "#B5B5C3"
        }
      />
    </svg>
  );
};
export const IdIconRegister = props => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M19.4791 19.25H2.52089C1.13028 19.25 0 18.1197 0 16.7291V5.27089C0 3.88028 1.13028 2.75 2.52089 2.75H19.4791C20.8697 2.75 22 3.88028 22 5.27089V16.7291C22 18.1197 20.8697 19.25 19.4791 19.25ZM2.52089 4.125C1.88928 4.125 1.375 4.63928 1.375 5.27089V16.7291C1.375 17.3607 1.88928 17.875 2.52089 17.875H19.4791C20.1107 17.875 20.625 17.3607 20.625 16.7291V5.27089C20.625 4.63928 20.1107 4.125 19.4791 4.125H2.52089Z"
          fill={
            props.step === 0
              ? "#3699FF"
              : props.step > 0
              ? "#00C233"
              : "#B5B5C3"
          }
        />
        <path
          d="M6.87498 10.9999C5.61177 10.9999 4.58337 9.97133 4.58337 8.70828C4.58337 7.44507 5.61177 6.4165 6.87498 6.4165C8.1382 6.4165 9.16659 7.44507 9.16659 8.70828C9.16659 9.97133 8.1382 10.9999 6.87498 10.9999ZM6.87498 7.79151C6.36993 7.79151 5.95837 8.20307 5.95837 8.70828C5.95837 9.21334 6.36993 9.6249 6.87498 9.6249C7.38004 9.6249 7.7916 9.21334 7.7916 8.70828C7.7916 8.20307 7.38004 7.79151 6.87498 7.79151Z"
          fill={
            props.step === 0
              ? "#3699FF"
              : props.step > 0
              ? "#00C233"
              : "#B5B5C3"
          }
        />
        <path
          d="M10.3125 15.5833C9.933 15.5833 9.625 15.2753 9.625 14.8958V14.4374C9.625 13.8058 9.11072 13.2915 8.47911 13.2915H5.27089C4.63928 13.2915 4.125 13.8058 4.125 14.4374V14.8958C4.125 15.2753 3.817 15.5833 3.4375 15.5833C3.058 15.5833 2.75 15.2753 2.75 14.8958V14.4374C2.75 13.0468 3.88028 11.9165 5.27089 11.9165H8.47911C9.86972 11.9165 11 13.0468 11 14.4374V14.8958C11 15.2753 10.692 15.5833 10.3125 15.5833Z"
          fill={
            props.step === 0
              ? "#3699FF"
              : props.step > 0
              ? "#00C233"
              : "#B5B5C3"
          }
        />
        <path
          d="M18.5625 8.25H13.5209C13.1414 8.25 12.8334 7.942 12.8334 7.5625C12.8334 7.183 13.1414 6.875 13.5209 6.875H18.5625C18.942 6.875 19.25 7.183 19.25 7.5625C19.25 7.942 18.942 8.25 18.5625 8.25Z"
          fill={
            props.step === 0
              ? "#3699FF"
              : props.step > 0
              ? "#00C233"
              : "#B5B5C3"
          }
        />
        <path
          d="M18.5625 11.9165H13.5209C13.1414 11.9165 12.8334 11.6085 12.8334 11.229C12.8334 10.8495 13.1414 10.5415 13.5209 10.5415H18.5625C18.942 10.5415 19.25 10.8495 19.25 11.229C19.25 11.6085 18.942 11.9165 18.5625 11.9165Z"
          fill={
            props.step === 0
              ? "#3699FF"
              : props.step > 0
              ? "#00C233"
              : "#B5B5C3"
          }
        />
        <path
          d="M18.5625 15.5835H13.5209C13.1414 15.5835 12.8334 15.2755 12.8334 14.896C12.8334 14.5165 13.1414 14.2085 13.5209 14.2085H18.5625C18.942 14.2085 19.25 14.5165 19.25 14.896C19.25 15.2755 18.942 15.5835 18.5625 15.5835Z"
          fill={
            props.step === 0
              ? "#3699FF"
              : props.step > 0
              ? "#00C233"
              : "#B5B5C3"
          }
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const IdIconLSP = props => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M19.4791 19.25H2.52089C1.13028 19.25 0 18.1197 0 16.7291V5.27089C0 3.88028 1.13028 2.75 2.52089 2.75H19.4791C20.8697 2.75 22 3.88028 22 5.27089V16.7291C22 18.1197 20.8697 19.25 19.4791 19.25ZM2.52089 4.125C1.88928 4.125 1.375 4.63928 1.375 5.27089V16.7291C1.375 17.3607 1.88928 17.875 2.52089 17.875H19.4791C20.1107 17.875 20.625 17.3607 20.625 16.7291V5.27089C20.625 4.63928 20.1107 4.125 19.4791 4.125H2.52089Z"
          fill={
            props.step === 1
              ? "#3699FF"
              : props.step > 1
              ? "#00C233"
              : "#B5B5C3"
          }
        />
        <path
          d="M6.87498 10.9999C5.61177 10.9999 4.58337 9.97133 4.58337 8.70828C4.58337 7.44507 5.61177 6.4165 6.87498 6.4165C8.1382 6.4165 9.16659 7.44507 9.16659 8.70828C9.16659 9.97133 8.1382 10.9999 6.87498 10.9999ZM6.87498 7.79151C6.36993 7.79151 5.95837 8.20307 5.95837 8.70828C5.95837 9.21334 6.36993 9.6249 6.87498 9.6249C7.38004 9.6249 7.7916 9.21334 7.7916 8.70828C7.7916 8.20307 7.38004 7.79151 6.87498 7.79151Z"
          fill={
            props.step === 1
              ? "#3699FF"
              : props.step > 1
              ? "#00C233"
              : "#B5B5C3"
          }
        />
        <path
          d="M10.3125 15.5833C9.933 15.5833 9.625 15.2753 9.625 14.8958V14.4374C9.625 13.8058 9.11072 13.2915 8.47911 13.2915H5.27089C4.63928 13.2915 4.125 13.8058 4.125 14.4374V14.8958C4.125 15.2753 3.817 15.5833 3.4375 15.5833C3.058 15.5833 2.75 15.2753 2.75 14.8958V14.4374C2.75 13.0468 3.88028 11.9165 5.27089 11.9165H8.47911C9.86972 11.9165 11 13.0468 11 14.4374V14.8958C11 15.2753 10.692 15.5833 10.3125 15.5833Z"
          fill={
            props.step === 1
              ? "#3699FF"
              : props.step > 1
              ? "#00C233"
              : "#B5B5C3"
          }
        />
        <path
          d="M18.5625 8.25H13.5209C13.1414 8.25 12.8334 7.942 12.8334 7.5625C12.8334 7.183 13.1414 6.875 13.5209 6.875H18.5625C18.942 6.875 19.25 7.183 19.25 7.5625C19.25 7.942 18.942 8.25 18.5625 8.25Z"
          fill={
            props.step === 1
              ? "#3699FF"
              : props.step > 1
              ? "#00C233"
              : "#B5B5C3"
          }
        />
        <path
          d="M18.5625 11.9165H13.5209C13.1414 11.9165 12.8334 11.6085 12.8334 11.229C12.8334 10.8495 13.1414 10.5415 13.5209 10.5415H18.5625C18.942 10.5415 19.25 10.8495 19.25 11.229C19.25 11.6085 18.942 11.9165 18.5625 11.9165Z"
          fill={
            props.step === 1
              ? "#3699FF"
              : props.step > 1
              ? "#00C233"
              : "#B5B5C3"
          }
        />
        <path
          d="M18.5625 15.5835H13.5209C13.1414 15.5835 12.8334 15.2755 12.8334 14.896C12.8334 14.5165 13.1414 14.2085 13.5209 14.2085H18.5625C18.942 14.2085 19.25 14.5165 19.25 14.896C19.25 15.2755 18.942 15.5835 18.5625 15.5835Z"
          fill={
            props.step === 1
              ? "#3699FF"
              : props.step > 1
              ? "#00C233"
              : "#B5B5C3"
          }
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const DashboardIcon = props => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4691 16.7651C12.0175 17.2043 12.7972 17.204 13.3453 16.7645L20.0172 11.4133L20.2462 11.2306C20.9979 10.6309 20.9991 9.48873 20.2487 8.88744L13.3454 3.35603C12.7972 2.91681 12.0177 2.91681 11.4695 3.35603L4.56169 8.89102C3.81269 9.49116 3.81221 10.6306 4.56069 11.2314L4.78736 11.4133L11.4691 16.7651Z"
        fill={props.active ? "white" : "#101651"}
      />
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3347 19.4702C12.7866 19.9094 12.0072 19.9094 11.459 19.4704L5.52621 14.7185C5.11478 14.389 4.51294 14.4616 4.19168 14.8795C3.87519 15.2913 3.95204 15.8815 4.36341 16.1985L11.4902 21.6902C12.0297 22.106 12.7815 22.106 13.3211 21.6904L20.4445 16.2034C20.8594 15.8838 20.9367 15.2885 20.6172 14.8736C20.2932 14.4529 19.6872 14.3802 19.2729 14.7121L13.3347 19.4702Z"
        fill={props.active ? "white" : "#101651"}
      />
    </svg>
  );
};
export const PersonalDataIcon = props => {
  return (
    <svg
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.50403 0C4.75338 0 2.52354 2.23935 2.52354 5.00173C2.52354 7.7641 4.75338 10.0035 7.50403 10.0035C10.2547 10.0035 12.4845 7.7641 12.4845 5.00173C12.4845 2.23935 10.2547 0 7.50403 0ZM7.50401 1.35719C9.50828 1.35719 11.1331 2.9889 11.1331 5.00173C11.1331 7.01455 9.50828 8.64626 7.50401 8.64626C5.49973 8.64626 3.87495 7.01455 3.87495 5.00173C3.87495 2.9889 5.49973 1.35719 7.50401 1.35719ZM5.46567 12.0196C4.73656 12.0702 3.99957 12.1743 3.27262 12.3301C1.86954 12.6191 0.747049 13.1965 0.269287 14.1561C0.0890882 14.5314 -0.00150968 14.9332 1.90265e-05 15.34C-0.000521571 15.7439 0.0893428 16.1463 0.263079 16.5143C0.721822 17.4629 1.71357 17.9997 3.05273 18.2973L3.29262 18.3473C3.99983 18.5069 4.73704 18.6143 5.47919 18.6647C5.54239 18.6832 5.69304 18.7005 5.85746 18.7089L5.99271 18.7139C6.06224 18.7156 6.14117 18.716 6.25876 18.716C7.32548 18.7746 8.43133 18.7576 9.53205 18.6639C10.1186 18.6237 10.7092 18.547 11.2947 18.4346L11.7329 18.3436C13.179 18.0584 14.2618 17.5159 14.7362 16.5154C15.0879 15.7726 15.0879 14.9107 14.7363 14.1682C14.2631 13.1702 13.1941 12.6322 11.7219 12.329C11.1443 12.2057 10.5574 12.1144 9.96626 12.0561L9.5341 12.0196C8.18056 11.9002 6.81921 11.9002 5.46567 12.0196ZM9.41583 13.3716L9.42772 13.3725C10.1061 13.4203 10.7804 13.5155 11.4456 13.6575C12.5391 13.8828 13.2812 14.2562 13.516 14.7514C13.6928 15.1247 13.6928 15.5585 13.5159 15.9322C13.2965 16.3949 12.63 16.7523 11.6667 16.9707L11.4558 17.0154C10.7775 17.1667 10.1054 17.2643 9.42895 17.3107C8.3793 17.3999 7.33588 17.4161 6.29509 17.3598L5.92608 17.3534C5.82365 17.3482 5.73732 17.3383 5.65731 17.3223C5.02379 17.2744 4.45374 17.1988 3.90024 17.0891L3.56976 17.0191C2.47284 16.8041 1.72419 16.429 1.48146 15.9272C1.39653 15.7472 1.35116 15.544 1.35143 15.3384C1.35067 15.1339 1.39544 14.9353 1.48235 14.7543C1.71836 14.2804 2.51174 13.8722 3.54942 13.6585C4.21943 13.5149 4.89338 13.4197 5.57149 13.3725C6.85877 13.2591 8.14098 13.2591 9.41583 13.3716Z"
        fill={props.active ? "white" : "#01B1FD"}
      />
    </svg>
  );
};
export const DidbMiniLogo = props => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.36434 1.47867C8.36434 2.61611 8.36434 3.75355 8.36434 4.891C6.55865 4.90521 5.0942 6.36967 5.0942 8.17536C5.0942 9.98104 6.54444 11.4455 8.35012 11.4597C8.35012 13.1232 8.35012 14.7867 8.35012 16.4502C12.8288 13.7773 15.8146 9.79621 15.2174 2.55924C13.2838 1.80569 11.0942 1.56398 8.36434 1.47867ZM8.35012 18C2.97571 14.7867 -0.621442 9.99526 0.0894586 1.27962C4.46861 -0.42654 12.2459 -0.42654 16.625 1.27962C17.3501 9.99526 13.7245 14.7867 8.35012 18Z"
        fill={props.active ? "white" : "#2C2C70"}
      />
      <path
        d="M8.37854 3.82422C5.9757 3.82422 4.02783 5.77209 4.02783 8.17493C4.02783 10.5778 5.9757 12.5256 8.37854 12.5256C10.7814 12.5256 12.7293 10.5778 12.7293 8.17493C12.7293 5.77209 10.7814 3.82422 8.37854 3.82422ZM6.2885 7.71995L7.52546 8.80052C9.843 6.48299 10.625 6.01379 10.625 6.01379C10.625 6.01379 10.7814 6.01379 10.9378 6.31237C9.54442 7.54934 7.83826 10.3361 7.83826 10.3361C7.83826 10.3361 7.21267 9.5683 5.8193 8.17493L6.2885 7.71995Z"
        fill={"#E64110"}
      />
    </svg>
  );
};
export const PaperIcon = props => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.107 0.0117C11.0639 0.00401204 11.0196 0 10.9743 0C10.929 0 10.8847 0.00401204 10.8416 0.0117H4.584C2.0967 0.0117 0 2.02953 0 4.4907V15.2037C0 17.8043 2.0046 19.8647 4.584 19.8647H12.573C15.0263 19.8647 17.052 17.7028 17.052 15.2037V6.0377C17.052 5.84408 16.9771 5.65797 16.843 5.5183L11.778 0.242299C11.6366 0.0949779 11.4412 0.0117 11.237 0.0117H11.107ZM10.2243 1.5109L4.584 1.5117C2.91254 1.5117 1.5 2.8711 1.5 4.4907V15.2037C1.5 16.9849 2.84239 18.3647 4.584 18.3647H12.573C14.1753 18.3647 15.552 16.8954 15.552 15.2037L15.5514 6.98309L14.6759 6.98607C14.3422 6.98567 13.9627 6.98496 13.5407 6.984C11.7712 6.98026 10.327 5.59329 10.2295 3.84739L10.2243 3.659V1.5109ZM14.7305 5.48384L13.544 5.484C12.5385 5.48188 11.7243 4.66546 11.7243 3.659V2.35245L14.7305 5.48384ZM10.7843 12.8076C11.1985 12.8076 11.5343 13.1434 11.5343 13.5576C11.5343 13.9373 11.2521 14.2511 10.8861 14.3008L10.7843 14.3076H5.3873C4.97309 14.3076 4.6373 13.9718 4.6373 13.5576C4.6373 13.1779 4.91945 12.8641 5.28553 12.8144L5.3873 12.8076H10.7843ZM9.4928 8.6054C9.4928 8.19119 9.15701 7.8554 8.7428 7.8554H5.3868L5.28503 7.86225C4.91895 7.91191 4.6368 8.2257 4.6368 8.6054C4.6368 9.01961 4.97259 9.3554 5.3868 9.3554H8.7428L8.84457 9.34855C9.21065 9.29889 9.4928 8.9851 9.4928 8.6054Z"
        fill={props.active ? "white" : "#F2C94D"}
      />
    </svg>
  );
};
export const TruckIcon = props => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6618 12.8878C17.6171 13.6821 17.3137 14.3336 16.6622 14.7977C16.2427 15.1011 15.7697 15.2439 15.261 15.235C14.6274 15.2171 14.083 14.9851 13.6457 14.5389C13.1995 14.0927 12.9853 13.5393 12.9585 12.9057C10.9862 12.9057 9.02276 12.9057 7.0415 12.9057C6.99688 13.7 6.67559 14.3693 6.00625 14.8245C5.58679 15.119 5.11379 15.2618 4.59616 15.235C3.35564 15.1725 2.62383 14.4229 2.31147 12.8878C2.1776 12.8878 2.02588 12.8878 1.88309 12.8878C0.731816 12.8878 0 12.156 0 11.0047C0 7.97039 0 4.93603 0 1.90167C0 0.750394 0.740741 0.000728538 1.89201 0.000728538C4.23025 0.000728538 6.55957 0.000728538 8.89781 0.000728538C9.74565 0.000728538 10.5935 -0.00819605 11.4413 0.0364269C12.2178 0.0810498 12.8871 0.786092 12.9496 1.56253C12.9674 1.81242 12.9496 2.06231 12.9496 2.35682C13.0656 2.35682 13.1459 2.35682 13.2173 2.35682C13.9759 2.35682 14.7345 2.35682 15.4931 2.35682C16.7961 2.35682 17.7332 2.94584 18.3043 4.11496C18.822 5.15022 19.3485 6.18547 19.8572 7.22964C19.9375 7.39921 19.9822 7.59555 19.9911 7.78297C20 8.86284 20 9.94272 20 11.0137C20 12.156 19.2682 12.8878 18.1348 12.8878C17.9741 12.8878 17.8313 12.8878 17.6618 12.8878ZM11.7894 8.1935C11.7894 8.0864 11.7894 7.99716 11.7894 7.90791C11.7894 5.9088 11.7894 3.9097 11.7894 1.91059C11.7894 1.38404 11.593 1.17877 11.0665 1.17877C8.00535 1.17877 4.94422 1.17877 1.88309 1.17877C1.39224 1.17877 1.17805 1.39296 1.17805 1.88382C1.17805 3.9097 1.17805 5.92665 1.17805 7.95254C1.17805 8.03286 1.17805 8.10425 1.17805 8.1935C4.72111 8.1935 8.23739 8.1935 11.7894 8.1935ZM11.7805 9.38939C8.23739 9.38939 4.71218 9.38939 1.16912 9.38939C1.16912 9.94272 1.16912 10.4782 1.16912 11.0047C1.16912 11.0672 1.16912 11.1386 1.17805 11.2011C1.22267 11.4956 1.45471 11.7009 1.76707 11.7098C1.98126 11.7187 2.19545 11.7009 2.40964 11.7098C2.57028 11.7187 2.67738 11.6652 2.77555 11.5313C3.71263 10.2015 5.66711 10.2105 6.59527 11.5402C6.68452 11.6652 6.76484 11.7187 6.91655 11.7098C8.46051 11.7009 10.0134 11.7098 11.5573 11.7098C11.6287 11.7098 11.7001 11.7098 11.7715 11.7098C11.7805 10.9244 11.7805 10.1748 11.7805 9.38939ZM12.9853 3.53486C12.9853 6.27471 12.9853 8.99671 12.9853 11.7098C13.1816 11.7544 13.2887 11.7009 13.3958 11.5491C14.2436 10.3532 16.0018 10.1926 16.9656 11.2725C17.3137 11.6652 17.6439 11.7723 18.0991 11.7276C18.1615 11.7187 18.2151 11.7276 18.2776 11.7187C18.5631 11.683 18.7863 11.4867 18.813 11.2011C18.8309 10.9958 18.813 10.7906 18.813 10.5496C18.6256 10.5496 18.465 10.5496 18.2954 10.5496C17.9027 10.5407 17.6528 10.2997 17.6528 9.96057C17.6528 9.62143 17.9116 9.38047 18.3043 9.37154C18.4739 9.37154 18.6435 9.37154 18.813 9.37154C18.813 8.96101 18.813 8.59511 18.813 8.20242C18.7149 8.20242 18.6256 8.20242 18.5364 8.20242C17.3048 8.20242 16.0643 8.20242 14.8327 8.20242C14.3507 8.20242 14.1365 7.99716 14.1365 7.51523C14.1365 6.26579 14.1365 5.01635 14.1365 3.7669C14.1365 3.68658 14.1276 3.60626 14.1276 3.53486C13.726 3.53486 13.3601 3.53486 12.9853 3.53486ZM18.4471 7.02438C18.2776 6.68524 18.1258 6.36396 17.9652 6.0516C17.6796 5.48043 17.4119 4.90033 17.0906 4.347C16.7336 3.72228 15.9661 3.401 15.3235 3.54379C15.3235 4.69506 15.3235 5.85526 15.3235 7.01545C16.3588 7.02438 17.3851 7.02438 18.4471 7.02438ZM15.3146 14.057C15.9572 14.048 16.4748 13.5393 16.4659 12.8878C16.4659 12.2453 15.9482 11.7276 15.3057 11.7276C14.6542 11.7276 14.1276 12.2542 14.1365 12.9057C14.1544 13.5483 14.672 14.057 15.3146 14.057ZM4.65863 14.057C5.3012 14.0748 5.82776 13.5661 5.8456 12.9235C5.86345 12.272 5.34583 11.7366 4.69433 11.7276C4.05176 11.7187 3.52521 12.2363 3.51629 12.87C3.51629 13.5126 4.01606 14.0391 4.65863 14.057Z"
        fill={props.active ? "white" : "#F3994B"}
      />
    </svg>
  );
};
export const SettingsIcon = props => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1161 2.17328e-07H8.88106C8.1855 2.17328e-07 7.51861 0.271551 7.02796 0.754574C6.59307 1.1827 6.32704 1.74716 6.27575 2.34781L6.26724 2.54181C6.25775 3.17352 5.74742 3.66634 5.12101 3.66628C4.97895 3.6648 4.83141 3.63238 4.69559 3.5713L4.56235 3.50171C3.33155 2.81017 1.73128 3.23376 1.00918 4.46166L0.359895 5.50695C-0.330507 6.68048 0.0100074 8.15476 1.12449 8.91408L1.27948 9.01151C1.66149 9.22838 1.87987 9.59896 1.87987 10C1.87987 10.3688 1.69491 10.7137 1.38645 10.9228L1.28115 10.9875C0.126514 11.6412 -0.328427 13.0841 0.251966 14.2844L0.33679 14.4442L0.974125 15.5224C1.30539 16.1083 1.87306 16.5497 2.54445 16.7366C3.13953 16.9023 3.7746 16.8565 4.33762 16.6084L4.51565 16.5213C4.81529 16.3516 5.12484 16.3109 5.41538 16.3871C5.70591 16.4633 5.95336 16.65 6.1027 16.9057C6.18504 17.0418 6.23337 17.1822 6.25063 17.3277L6.25912 17.4753C6.25765 18.8493 7.43219 20 8.88106 20H10.1164C11.4845 20 12.62 18.9703 12.731 17.6414L12.7391 17.4698C12.7383 17.1379 12.8582 16.8524 13.0727 16.6422C13.2872 16.432 13.5786 16.3146 13.882 16.316C14.0214 16.3199 14.1746 16.3541 14.3166 16.4163L14.4527 16.485C15.6011 17.1344 17.1058 16.8008 17.8808 15.7089L17.9803 15.557L18.6399 14.4804C18.995 13.8833 19.0912 13.1817 18.9119 12.523C18.753 11.9391 18.3887 11.4297 17.8843 11.0841L17.7174 10.9793C17.4272 10.8149 17.236 10.5708 17.158 10.2844C17.08 9.99795 17.1218 9.69291 17.2742 9.43678C17.3585 9.29258 17.4706 9.17256 17.6051 9.08068L17.8624 8.92228C18.9043 8.22927 19.2945 6.86519 18.7461 5.71842L18.6892 5.60674C18.6769 5.57762 18.6627 5.54922 18.6465 5.52174L18.0333 4.47928C17.3511 3.31918 15.8759 2.86897 14.646 3.4355L14.4821 3.51839C14.1882 3.68688 13.8779 3.72947 13.5857 3.65514C13.2935 3.58081 13.0435 3.39567 12.8908 3.14055C12.8124 3.01116 12.7641 2.87079 12.7468 2.72535L12.7383 2.57766C12.7599 1.94968 12.4925 1.27681 11.9983 0.778711C11.5041 0.280615 10.8251 -0.000285223 10.1161 2.17328e-07ZM8.88093 1.44815H10.1163C10.4262 1.44802 10.7227 1.5707 10.9386 1.78824C11.1544 2.00578 11.2712 2.29964 11.2623 2.6029L11.2754 2.85495C11.3201 3.24025 11.4355 3.57545 11.618 3.87657C11.9672 4.46006 12.5422 4.88587 13.2142 5.05682C13.8862 5.22777 14.6 5.12982 15.1982 4.78456L15.3013 4.73306L15.4123 4.68951C15.9007 4.52894 16.4763 4.73216 16.7529 5.20249L17.3377 6.19767L17.3504 6.2257L17.4211 6.35925C17.6577 6.85545 17.4599 7.48311 16.9479 7.77655L16.7872 7.87573C16.4462 8.10774 16.1848 8.38757 15.9945 8.71303C15.6469 9.29748 15.5508 9.99907 15.7301 10.6578C15.8931 11.2567 16.2715 11.7752 16.7921 12.1199L17.0644 12.2886C17.2565 12.4211 17.4149 12.6426 17.484 12.8964C17.5619 13.1828 17.5201 13.4879 17.3678 13.744L16.7234 14.7961L16.651 14.9071C16.3528 15.3262 15.7645 15.4819 15.2686 15.2686L14.9526 15.1104C14.6002 14.9551 14.2555 14.8782 13.9052 14.869C13.1912 14.8654 12.5211 15.1355 12.0277 15.6189C11.5343 16.1023 11.2586 16.7589 11.262 17.4425L11.2564 17.5515C11.2097 18.1027 10.7136 18.5527 10.1163 18.5527H8.88093C8.29034 18.5527 7.80412 18.1149 7.74192 17.5525L7.72176 17.1989C7.67708 16.8136 7.56165 16.4784 7.37924 16.1773C7.04015 15.5963 6.46847 15.1649 5.79724 14.989C5.126 14.813 4.41082 14.907 3.81066 15.2501L3.70195 15.3022C3.48555 15.3968 3.20817 15.4168 2.94829 15.3444C2.65507 15.2628 2.40715 15.07 2.25939 14.8088L1.63014 13.7453L1.57385 13.6387C1.33549 13.1444 1.5334 12.5167 2.04625 12.226L2.20206 12.13C2.93399 11.6344 3.35741 10.845 3.35741 10.0004C3.35741 9.14336 2.92183 8.34707 2.20382 7.87141L1.9431 7.70966C1.48243 7.39507 1.33363 6.75085 1.63115 6.24497L2.28044 5.19966C2.60477 4.64856 3.30366 4.46356 3.85177 4.77126L4.04413 4.87067C4.40342 5.03334 4.75574 5.11075 5.11313 5.11439C6.49956 5.11457 7.63326 4.07128 7.73671 2.74191L7.75015 2.43702C7.77044 2.20782 7.88612 1.96237 8.0752 1.77623C8.28853 1.56622 8.57849 1.44815 8.88093 1.44815ZM9.5032 6.73182C7.66092 6.73182 6.16745 8.19503 6.16745 10C6.16745 11.805 7.66092 13.2682 9.5032 13.2682C11.3455 13.2682 12.839 11.805 12.839 10C12.839 8.19503 11.3455 6.73182 9.5032 6.73182ZM9.50324 8.18034C10.5294 8.18034 11.3613 8.99538 11.3613 10.0008C11.3613 11.0062 10.5294 11.8212 9.50324 11.8212C8.47705 11.8212 7.64516 11.0062 7.64516 10.0008C7.64516 8.99538 8.47705 8.18034 9.50324 8.18034Z"
        fill={props.active ? "white" : "#2E2E98"}
      />
    </svg>
  );
};
export const MenuTimesIcon = () => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.25 7.75L7.75 23.25"
        stroke="#B5B5C3"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 7.75L23.25 23.25"
        stroke="#B5B5C3"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LogoutIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00504149 15.8843C0.114487 18.2468 2.06393 20.1279 4.4535 20.1279L9.36875 20.1279L9.57891 20.1231C11.947 20.0134 13.8321 18.0602 13.8321 15.6656L13.8321 14.7266L13.8252 14.6242C13.7752 14.2558 13.4594 13.9718 13.0773 13.9718C12.6605 13.9718 12.3225 14.3097 12.3225 14.7266L12.3225 15.6656L12.3175 15.8391C12.2277 17.3895 10.9425 18.6183 9.36875 18.6183L4.4535 18.6183L4.2805 18.6133C2.73495 18.5238 1.50979 17.2427 1.50979 15.6746L1.50979 4.46336L1.51481 4.28982C1.60466 2.73942 2.89067 1.50958 4.46357 1.50958L9.37982 1.50958L9.55269 1.51458C11.0971 1.60414 12.3225 2.88597 12.3225 4.45329L12.3225 5.40132L12.3294 5.50374C12.3794 5.87216 12.6952 6.15612 13.0773 6.15612C13.4942 6.15612 13.8321 5.81818 13.8321 5.40132L13.8321 4.45329L13.827 4.23757C13.7144 1.87873 11.7662 -1.40364e-05 9.37982 -1.42451e-05L4.46357 -1.46748e-05L4.25347 0.00484332C1.88612 0.114565 0.000196128 2.0689 0.000195919 4.46336L0.000194939 15.6746L0.00504149 15.8843ZM15.3652 6.59688C15.6326 6.32836 16.0519 6.30314 16.3479 6.52178L16.4327 6.59469L19.3794 9.52934C19.6487 9.79754 19.6732 10.2183 19.4528 10.5142L19.4504 10.517C19.4292 10.5453 19.406 10.572 19.3812 10.5969L19.3794 10.599L16.4327 13.5336C16.1373 13.8278 15.6594 13.8268 15.3652 13.5314C15.0978 13.2629 15.0743 12.8435 15.2942 12.5485L15.3674 12.464L17.0187 10.8189L6.7285 10.8189C6.31163 10.8189 5.9737 10.481 5.9737 10.0641C5.9737 9.682 6.25766 9.3662 6.62608 9.31622L6.7285 9.30933L17.0184 9.30933L15.3674 7.66433C15.0989 7.39691 15.0737 6.97763 15.2923 6.68169L15.3652 6.59688Z"
        fill="#E64110"
      />
    </svg>
  );
};
export const WidgetMenuIcon = () => {
  return (
    <svg
      width="17"
      height="6"
      viewBox="0 0 17 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="11" width="6" height="6" rx="2" fill="#B5B5C3" />
      <rect width="6" height="6" rx="2" fill="#B5B5C3" fillOpacity="0.7" />
    </svg>
  );
};
export const DashboardLicenseIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="12" fill="#EEE5FF" />
      <path
        d="M25.3125 27.8711H14.6875C12.1028 27.8711 10 25.7683 10 23.1836V16.8164C10 14.2317 12.1028 12.1289 14.6875 12.1289H25.3125C27.8972 12.1289 30 14.2317 30 16.8164V23.1836C30 25.7683 27.8972 27.8711 25.3125 27.8711ZM14.6875 13.6914C12.9644 13.6914 11.5625 15.0933 11.5625 16.8164V23.1836C11.5625 24.9067 12.9644 26.3086 14.6875 26.3086H25.3125C27.0356 26.3086 28.4375 24.9067 28.4375 23.1836V16.8164C28.4375 15.0933 27.0356 13.6914 25.3125 13.6914H14.6875ZM16.3672 20.0586C15.0533 20.0586 13.9844 18.9897 13.9844 17.6758C13.9844 16.3619 15.0533 15.293 16.3672 15.293C17.6811 15.293 18.75 16.3619 18.75 17.6758C18.75 18.9897 17.6811 20.0586 16.3672 20.0586ZM16.3672 16.8555C15.9148 16.8555 15.5469 17.2234 15.5469 17.6758C15.5469 18.1281 15.9148 18.4961 16.3672 18.4961C16.8195 18.4961 17.1875 18.1281 17.1875 17.6758C17.1875 17.2234 16.8195 16.8555 16.3672 16.8555ZM26.9141 16.1133C26.9141 15.6818 26.5643 15.332 26.1328 15.332H20.8594C20.4279 15.332 20.0781 15.6818 20.0781 16.1133C20.0781 16.5448 20.4279 16.8945 20.8594 16.8945H26.1328C26.5643 16.8945 26.9141 16.5448 26.9141 16.1133ZM26.9141 19.2773C26.9141 18.8459 26.5643 18.4961 26.1328 18.4961H20.8594C20.4279 18.4961 20.0781 18.8459 20.0781 19.2773C20.0781 19.7088 20.4279 20.0586 20.8594 20.0586H26.1328C26.5643 20.0586 26.9141 19.7088 26.9141 19.2773ZM26.9141 23.9258C26.9141 23.4943 26.5643 23.1445 26.1328 23.1445H22.2656C21.8341 23.1445 21.4844 23.4943 21.4844 23.9258C21.4844 24.3573 21.8341 24.707 22.2656 24.707H26.1328C26.5643 24.707 26.9141 24.3573 26.9141 23.9258ZM19.7266 23.9648C19.7266 23.1379 19.4024 22.3669 18.8137 21.7938C18.2335 21.229 17.4599 20.918 16.6354 20.918H16.2076C14.5009 20.918 13.164 22.2563 13.164 23.9648C13.164 24.3963 13.5138 24.7461 13.9453 24.7461C14.3768 24.7461 14.7265 24.3963 14.7265 23.9648C14.7265 23.1186 15.3632 22.4805 16.2076 22.4805H16.6354C17.4926 22.4805 18.1641 23.1325 18.1641 23.9648C18.1641 24.3963 18.5138 24.7461 18.9453 24.7461C19.3768 24.7461 19.7266 24.3963 19.7266 23.9648Z"
        fill="#8950FC"
      />
    </svg>
  );
};
export const DashboardPassportIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="12" fill="#FFF4DE" />
      <g clipPath="url(#clip0)">
        <path
          d="M24.0715 25.0237L15.737 25.0225C15.5071 25.0225 15.3203 25.2088 15.3203 25.4391C15.3203 25.669 15.5067 25.8558 15.737 25.8558L24.0715 25.857C24.3014 25.857 24.4882 25.6707 24.4882 25.4404C24.4882 25.2104 24.3018 25.0237 24.0715 25.0237Z"
          fill="#FFA800"
        />
        <path
          d="M22.404 26.6895H17.404C17.1737 26.6895 16.9873 26.8758 16.9873 27.1061C16.9873 27.3364 17.1737 27.5228 17.404 27.5228H22.404C22.6343 27.5228 22.8206 27.3364 22.8206 27.1061C22.8206 26.8758 22.6343 26.6895 22.404 26.6895Z"
          fill="#FFA800"
        />
        <path
          d="M19.9998 15C17.4726 15 15.4165 17.056 15.4165 19.5833C15.4165 22.1106 17.4726 24.1666 19.9998 24.1666C22.5271 24.1666 24.5831 22.1106 24.5831 19.5833C24.5831 17.056 22.5271 15 19.9998 15ZM16.2919 20H17.925C17.9711 21.135 18.2056 22.2637 18.6125 23.0602C17.3559 22.557 16.4486 21.3931 16.2919 20ZM17.9251 19.1667H16.292C16.4487 17.7736 17.3559 16.6097 18.6125 16.1064C18.2056 16.9029 17.9712 18.0317 17.9251 19.1667ZM19.9998 23.3333C19.5224 23.3333 18.851 22.0424 18.7665 20H21.2331C21.1486 22.0424 20.4772 23.3333 19.9998 23.3333ZM18.7665 19.1667C18.851 17.1242 19.5224 15.8334 19.9998 15.8334C20.4772 15.8334 21.1486 17.1242 21.2331 19.1667H18.7665ZM21.3871 23.0602C21.7941 22.2637 22.0285 21.135 22.0746 20H23.7077C23.551 21.3931 22.6437 22.557 21.3871 23.0602ZM22.0746 19.1667C22.0285 18.0317 21.7941 16.9029 21.3871 16.1064C22.6437 16.6097 23.551 17.7736 23.7077 19.1667H22.0746Z"
          fill="#FFA800"
        />
        <path
          d="M25.8333 12.5001H25V11.6391C25 10.7287 24.2296 9.99091 23.3333 10.0001C23.2052 10.0014 23.0932 10.0191 22.961 10.0526L14.0774 12.5091C13.2004 12.5566 12.5 13.2782 12.5 14.1667V28.3334C12.5 29.2525 13.2475 30 14.1667 30H25.8333C26.7525 30 27.5 29.2526 27.5 28.3334V14.1667C27.4999 13.2476 26.7525 12.5001 25.8333 12.5001ZM23.175 10.8578C23.6612 10.7337 24.1666 11.1276 24.1666 11.6391V12.5001H17.2366L23.175 10.8578ZM26.6666 28.3334C26.6666 28.7927 26.2927 29.1667 25.8333 29.1667H14.1667C13.7073 29.1667 13.3334 28.7927 13.3334 28.3334V14.1667C13.3334 13.7074 13.7073 13.3334 14.1667 13.3334H25.8333C26.2927 13.3334 26.6666 13.7074 26.6666 14.1667V28.3334Z"
          fill="#FFA800"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(10 10)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const DashboardNationalIdIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="12" fill="#C9F7F5" />
      <path
        d="M28.1289 12.6445H11.8711C11.0977 12.6445 10.4492 13.2539 10.4492 14.0664V25.9336C10.4492 26.707 11.0586 27.3555 11.8711 27.3555H28.125C28.8984 27.3555 29.5469 26.707 29.5469 25.8945V14.0664C29.5508 13.2969 28.9414 12.6445 28.1289 12.6445ZM28.7773 25.8906C28.7773 26.2578 28.4922 26.5391 28.1289 26.5391H11.8711C11.5039 26.5391 11.2227 26.2539 11.2227 25.8906V14.0664C11.2227 13.6992 11.5078 13.418 11.8711 13.418H28.125C28.4922 13.418 28.7734 13.7031 28.7734 14.0664V25.8906H28.7773Z"
        fill="#1BC5BD"
      />
      <path
        d="M16.9531 15.2461H12.7266V19.4727H16.9531V15.2461ZM16.1797 18.6992H13.5391V16.0586H16.1797V18.6992Z"
        fill="#1BC5BD"
      />
      <path
        d="M21.543 21.5039H13.1328V22.3164H21.543V21.5039Z"
        fill="#1BC5BD"
      />
      <path d="M21.543 24.0625H13.1328V24.875H21.543V24.0625Z" fill="#1BC5BD" />
    </svg>
  );
};
export const DashboardDangerIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="12" fill="#EB5757" fillOpacity="0.15" />
      <path
        d="M18.5751 13.2163L11.5168 24.9997C11.3713 25.2517 11.2943 25.5374 11.2935 25.8284C11.2926 26.1195 11.368 26.4056 11.5122 26.6585C11.6563 26.9113 11.8641 27.122 12.1149 27.2696C12.3657 27.4171 12.6508 27.4965 12.9418 27.4997H27.0585C27.3495 27.4965 27.6346 27.4171 27.8854 27.2696C28.1362 27.122 28.344 26.9113 28.4881 26.6585C28.6322 26.4056 28.7076 26.1195 28.7068 25.8284C28.706 25.5374 28.629 25.2517 28.4835 24.9997L21.4251 13.2163C21.2766 12.9714 21.0674 12.7689 20.8178 12.6284C20.5682 12.4879 20.2866 12.4141 20.0001 12.4141C19.7137 12.4141 19.4321 12.4879 19.1825 12.6284C18.9329 12.7689 18.7237 12.9714 18.5751 13.2163V13.2163Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 17.5V20.8333"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 24.167H20.0088"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
/*
export const DashboardProfileImg = () => {
    return (
        <svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip3)">
                <rect x="8.77783" y="8.77734" width="61.4444" height="61.4444" rx="30.7222" fill="#1BC5BD"/>
                <g clipPath="url(#clip3)">
                    <path
                        d="M26.9389 41.3777C26.9389 41.3777 25.3364 34.8204 25.3364 32.5643C25.3364 27.7237 29.3425 27.7571 29.3425 27.7571L29.3432 27.7564C31.7295 23.7677 40.5595 23.751 40.5595 23.751L41.3607 25.3534C45.7674 23.9513 51.7765 23.751 51.7765 23.751C51.7765 23.751 52.9283 25.3534 53.379 27.7571C54.3129 32.7381 52.5777 41.3777 52.5777 41.3777H26.9389Z"
                        fill="#734A3E"/>
                    <path
                        d="M40.5595 23.751C40.5595 23.751 31.6961 23.751 29.3432 27.7564L29.3425 27.7571C29.3425 27.7571 25.3364 27.7237 25.3364 32.5643C25.3364 34.8204 26.9389 41.3777 26.9389 41.3777H32.1103L37.3547 34.1668C37.3547 34.1668 45.4336 30.0271 51.7765 23.751C51.7765 23.751 45.7674 23.9513 41.3607 25.3534L40.5595 23.751Z"
                        fill="#623F33"/>
                    <path
                        d="M55.7697 66.103L55.697 65.4484C55.6682 65.1895 55.435 65.0028 55.1761 65.0316L55.1353 65.0361L54.4316 59.4062C54.2784 58.1815 53.4358 57.1535 52.265 56.7633L47.6569 55.2272L47.7714 54.9984L46.0343 53.8403C45.6662 53.5948 45.1687 53.6943 44.9232 54.0626L44.6785 54.4297C44.6064 54.2465 44.5665 54.0485 44.5665 53.8434V51.2593L48.0178 49.8213C49.8093 49.0749 50.9761 47.3245 50.9761 45.3838V44.5826C52.3036 44.5826 53.3798 43.5064 53.3798 42.1789C53.3798 41.5455 53.1343 40.9696 52.7338 40.5402C53.1376 38.2528 54.1378 31.7999 53.3798 27.7571C52.9291 25.3534 51.7773 23.751 51.7773 23.751C51.7773 23.751 45.7682 23.9513 41.3615 25.3534L40.5603 23.751C40.5603 23.751 31.6969 23.751 29.344 27.7564L29.3433 27.7571C29.3433 27.7571 29.3423 27.7571 29.3404 27.7571C29.3366 27.7571 29.3289 27.7571 29.3178 27.7574C29.3067 27.7577 29.2918 27.7581 29.2738 27.7588C29.2558 27.7596 29.2344 27.7607 29.21 27.7623C29.1978 27.7631 29.1849 27.764 29.1712 27.7651C29.1301 27.7683 29.0824 27.7728 29.0289 27.779C28.9933 27.7832 28.9551 27.7881 28.9146 27.794C28.874 27.7999 28.8311 27.8067 28.7863 27.8146C28.7413 27.8227 28.6943 27.8316 28.6455 27.8419C27.6687 28.0472 25.9583 28.7487 25.4704 31.1445C25.4582 31.2044 25.4468 31.2654 25.4362 31.3274C25.4042 31.5135 25.3795 31.7092 25.3628 31.9153C25.3461 32.1213 25.3372 32.3374 25.3372 32.5643C25.3372 32.7406 25.3471 32.9431 25.3651 33.1667C25.3831 33.3902 25.4094 33.6349 25.4424 33.8955C25.449 33.9476 25.4559 34.0003 25.463 34.0537C25.6199 35.2272 25.9009 36.6885 26.176 37.9964C26.1885 38.0559 26.201 38.115 26.2135 38.1738C26.4006 39.0554 26.582 39.8564 26.7168 40.437C26.7281 40.4858 26.7391 40.5324 26.7497 40.5781C26.3698 41.003 26.1385 41.5639 26.1385 42.1789C26.1385 43.5064 27.2146 44.5826 28.5421 44.5826V45.3838C28.5421 47.3244 29.709 49.0748 31.5004 49.8213L34.9518 51.2595V53.8435C34.9518 54.0487 34.912 54.2467 34.8399 54.4298L34.5951 54.0627C34.3496 53.6945 33.8522 53.5949 33.484 53.8404L31.747 54.9985L31.8614 55.2273L27.2533 56.7634C26.0825 57.1536 25.2398 58.1816 25.0868 59.4063L24.383 65.0362L24.3422 65.0317C24.0832 65.003 23.8501 65.1895 23.8212 65.4485L23.7485 66.1031C23.7198 66.362 23.9064 66.5953 24.1653 66.624L25.3372 66.7542V68.6191C25.3372 69.5041 26.0546 70.2216 26.9397 70.2216H30.9457H48.5725H52.5786C53.4636 70.2216 54.181 69.5041 54.181 68.6191V66.7542L55.353 66.624C55.6119 66.5952 55.7985 66.3619 55.7697 66.103Z"
                        fill="#F6B47B"/>
                    <path
                        d="M54.4307 59.4067C54.2776 58.182 53.4349 57.154 52.2641 56.7638L47.0812 55.0361C46.3266 56.7379 42.1619 58.2037 42.1619 58.2037L40.5595 59.8062C40.5595 59.8125 39.0822 59.8062 38.957 59.8062L37.3546 58.2037C37.3546 58.2037 33.1899 56.738 32.4352 55.0361L27.2524 56.7638C26.0815 57.154 25.2388 58.182 25.0858 59.4067L24.3237 65.5031L30.9448 66.2159V70.222H48.5715V66.2159H55.2817L54.4307 59.4067Z"
                        fill="#FF4F4F"/>
                    <path
                        d="M26.9389 41.3777C26.9389 41.3777 25.3364 34.8204 25.3364 32.5643C25.3364 27.7237 29.3425 27.7571 29.3425 27.7571L29.3432 27.7564C31.6627 23.8178 40.5595 23.751 40.5595 23.751L41.3607 25.3534C45.7674 23.9513 51.7765 23.751 51.7765 23.751C51.7765 23.751 52.9283 25.3534 53.379 27.7571C54.3129 32.7381 52.5777 41.3777 52.5777 41.3777H26.9389Z"
                        fill="#734A3E"/>
                    <path
                        d="M40.5595 23.751C40.5595 23.751 31.6961 23.751 29.3432 27.7564L29.3425 27.7571C29.3425 27.7571 25.3364 27.7237 25.3364 32.5643C25.3364 34.8204 26.9389 41.3777 26.9389 41.3777H32.1103L37.3547 34.1668C37.3547 34.1668 45.4336 30.0271 51.7765 23.751C51.7765 23.751 45.7674 23.9513 41.3607 25.3534L40.5595 23.751Z"
                        fill="#623F33"/>
                    <path
                        d="M44.5655 51.1924H34.9509V53.8432C34.9509 54.42 34.6318 54.9279 34.1479 55.2112C40.8675 56.3873 44.5655 51.1924 44.5655 51.1924Z"
                        fill="#E2A071"/>
                    <path
                        d="M50.9754 39.7755V38.1731C50.9754 35.9606 49.1817 34.167 46.9693 34.167H32.5474C30.335 34.167 28.5413 35.9606 28.5413 38.1731V39.7755C27.2138 39.7755 26.1377 40.8516 26.1377 42.1791C26.1377 43.5067 27.2138 44.5828 28.5413 44.5828V45.384C28.5413 47.3247 29.7082 49.075 31.4996 49.8215L36.6766 51.9786C37.6531 52.3855 38.7004 52.5949 39.7583 52.5949C40.8161 52.5949 41.8633 52.3854 42.8398 51.9786L48.0171 49.8214C49.8085 49.0751 50.9754 47.3248 50.9754 45.384V44.5828C52.3029 44.5828 53.379 43.5067 53.379 42.1791C53.379 40.8516 52.3029 39.7755 50.9754 39.7755Z"
                        fill="#FDC88E"/>
                    <path
                        d="M34.1498 42.9798C33.7092 42.9798 33.3486 42.6193 33.3486 42.1786V41.3774C33.3486 40.9367 33.7092 40.5762 34.1498 40.5762C34.5905 40.5762 34.9511 40.9367 34.9511 41.3774V42.1786C34.9511 42.6193 34.5905 42.9798 34.1498 42.9798Z"
                        fill="#623F33"/>
                    <path
                        d="M45.3666 42.9798C44.926 42.9798 44.5654 42.6193 44.5654 42.1786V41.3774C44.5654 40.9367 44.926 40.5762 45.3666 40.5762C45.8073 40.5762 46.1679 40.9367 46.1679 41.3774V42.1786C46.1679 42.6193 45.8073 42.9798 45.3666 42.9798Z"
                        fill="#623F33"/>
                    <path
                        d="M39.7581 48.6103C38.3337 48.6103 37.0013 48.2598 36.1026 47.6483C35.7369 47.3996 35.6417 46.9011 35.891 46.5354C36.1394 46.17 36.6382 46.0749 37.004 46.3237C37.6338 46.7521 38.6635 47.008 39.7581 47.008C40.8528 47.008 41.8825 46.7521 42.5123 46.3237C42.8789 46.0742 43.3765 46.1696 43.6253 46.5354C43.8745 46.9011 43.7794 47.3996 43.4137 47.6483C42.5151 48.2598 41.1826 48.6103 39.7581 48.6103Z"
                        fill="#E2A071"/>
                    <path
                        d="M30.9449 66.8202V65.0068C30.9449 64.236 30.6671 63.491 30.1624 62.9084L25.7538 57.8193C25.3981 58.2697 25.1599 58.8138 25.0859 59.406L24.249 66.1009C25.5234 66.1774 28.9129 66.5745 30.9449 66.8202Z"
                        fill="#F23F44"/>
                    <path
                        d="M30.9449 65.765L24.3413 65.0312C24.0823 65.0025 23.8491 65.1891 23.8203 65.448L23.7476 66.1026C23.7188 66.3615 23.9054 66.5947 24.1643 66.6235L30.9449 67.3769V65.765Z"
                        fill="#D6343A"/>
                    <path
                        d="M48.5718 66.8202V65.0068C48.5718 64.236 48.8496 63.491 49.3543 62.9084L53.7628 57.8193C54.1186 58.2697 54.3567 58.8138 54.4308 59.406L55.2676 66.1009C53.9934 66.1774 50.6038 66.5745 48.5718 66.8202Z"
                        fill="#F23F44"/>
                    <path
                        d="M48.5718 65.765L55.1754 65.0312C55.4344 65.0025 55.6675 65.1891 55.6964 65.448L55.7691 66.1026C55.7978 66.3615 55.6113 66.5947 55.3524 66.6235L48.5718 67.3769V65.765Z"
                        fill="#D6343A"/>
                    <path
                        d="M34.5942 54.063L37.3546 58.2035L34.951 61.4084L31.7461 54.9987L33.4831 53.8407C33.8513 53.5953 34.3487 53.6947 34.5942 54.063Z"
                        fill="#F23F44"/>
                    <path
                        d="M44.9226 54.063L42.1621 58.2035L44.5658 61.4084L47.7706 54.9987L46.0336 53.8407C45.6654 53.5953 45.1681 53.6947 44.9226 54.063Z"
                        fill="#F23F44"/>
                    <path
                        d="M39.7582 66.2154C39.3158 66.2154 38.957 65.8566 38.957 65.4142V59.8057H40.5595V65.4142C40.5595 65.8567 40.2008 66.2154 39.7582 66.2154Z"
                        fill="#F23F44"/>
                    <path
                        d="M32.7473 48.1606C32.0981 47.4646 31.7463 46.5461 31.7463 45.5942V36.4011C34.5613 36.0885 40.6933 35.3438 46.9694 34.167H32.5474C32.2716 34.167 32.0045 34.1991 31.7462 34.2552V34.2477C29.9177 34.619 28.5413 36.235 28.5413 38.1731V39.7755C27.2138 39.7755 26.1377 40.8516 26.1377 42.1791C26.1377 43.5067 27.2138 44.5828 28.5413 44.5828V45.384C28.5413 47.3247 29.7082 49.0751 31.4996 49.8215L36.6765 51.9786C36.9299 52.0842 37.1885 52.1751 37.4504 52.2539C35.1625 50.5803 33.6396 49.1172 32.7473 48.1606Z"
                        fill="#F6B47B"/>
                </g>
            </g>
            <circle cx="39.5" cy="39.5" r="37" stroke="#E5EAEE" strokeWidth="5"/>
            <mask id="path-22-inside-1" fill="white">
                <path
                    d="M64.7583 68.283C65.1975 68.7835 65.1489 69.5471 64.6351 69.9709C57.9429 75.4914 49.6085 78.6627 40.9164 78.9746C31.822 79.3009 22.8939 76.477 15.6412 70.9803C8.38861 65.4836 3.25638 57.6512 1.11215 48.8071C-1.03209 39.9631 -0.0568089 30.6499 3.87313 22.442C7.80306 14.234 14.4466 7.63481 22.6806 3.75985C30.9147 -0.115108 40.2341 -1.02809 49.0636 1.17525C57.8931 3.37858 65.691 8.56306 71.1392 15.8523C76.3463 22.8191 79.1016 31.3001 78.9972 39.9748C78.9891 40.6407 78.4248 41.1574 77.7594 41.1291C77.0941 41.1007 76.5797 40.5381 76.5864 39.8722C76.668 31.7527 74.0818 23.8179 69.2073 17.2962C64.0919 10.452 56.7701 5.58407 48.4797 3.51526C40.1893 1.44646 31.4389 2.3037 23.7076 5.94206C15.9763 9.58042 9.7384 15.7767 6.04842 23.4835C2.35844 31.1903 1.4427 39.9348 3.45602 48.2389C5.46933 56.5429 10.2882 63.8971 17.098 69.0582C23.9078 74.2193 32.2908 76.8708 40.8299 76.5644C48.9667 76.2724 56.7697 73.3118 63.0436 68.1572C63.5582 67.7344 64.319 67.7824 64.7583 68.283Z"/>
            </mask>
            <path
                d="M64.7583 68.283C65.1975 68.7835 65.1489 69.5471 64.6351 69.9709C57.9429 75.4914 49.6085 78.6627 40.9164 78.9746C31.822 79.3009 22.8939 76.477 15.6412 70.9803C8.38861 65.4836 3.25638 57.6512 1.11215 48.8071C-1.03209 39.9631 -0.0568089 30.6499 3.87313 22.442C7.80306 14.234 14.4466 7.63481 22.6806 3.75985C30.9147 -0.115108 40.2341 -1.02809 49.0636 1.17525C57.8931 3.37858 65.691 8.56306 71.1392 15.8523C76.3463 22.8191 79.1016 31.3001 78.9972 39.9748C78.9891 40.6407 78.4248 41.1574 77.7594 41.1291C77.0941 41.1007 76.5797 40.5381 76.5864 39.8722C76.668 31.7527 74.0818 23.8179 69.2073 17.2962C64.0919 10.452 56.7701 5.58407 48.4797 3.51526C40.1893 1.44646 31.4389 2.3037 23.7076 5.94206C15.9763 9.58042 9.7384 15.7767 6.04842 23.4835C2.35844 31.1903 1.4427 39.9348 3.45602 48.2389C5.46933 56.5429 10.2882 63.8971 17.098 69.0582C23.9078 74.2193 32.2908 76.8708 40.8299 76.5644C48.9667 76.2724 56.7697 73.3118 63.0436 68.1572C63.5582 67.7344 64.319 67.7824 64.7583 68.283Z"
                stroke="#00C233" strokeWidth="12" mask="url(#path-22-inside-1)"/>
            <defs>
                <clipPath id="clip0">
                    <rect x="8.77783" y="8.77734" width="61.4444" height="61.4444" rx="30.7222" fill="white"/>
                </clipPath>
                <clipPath id="clip1">
                    <rect width="46.4706" height="46.4706" fill="white" transform="translate(16.5229 23.751)"/>
                </clipPath>
            </defs>
        </svg>
    )
}
 */
export const DashboardProfileCheckIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#4CAF50" fillOpacity="0.1" />
      <g clipPath="url(#clip99)">
        <path
          d="M13.1854 13.9276C12.9025 14.2111 12.5254 14.3671 12.1249 14.3671C11.7245 14.3671 11.3474 14.2111 11.0645 13.9276L8.93945 11.8026C8.65601 11.5196 8.5 11.1427 8.5 10.7421C8.5 10.3416 8.65601 9.96466 8.93945 9.68167C9.22244 9.39813 9.59945 9.24213 9.99999 9.24213C10.4004 9.24213 10.7774 9.39813 11.0604 9.68167L12.1249 10.7456L15.0634 7.80715C14.1034 6.98867 12.8604 6.49219 11.5 6.49219C8.46247 6.49219 6 8.95466 6 11.9921C6 15.0296 8.46247 17.492 11.5 17.492C14.5374 17.492 16.9999 15.0296 16.9999 11.9921C16.9999 11.4236 16.9134 10.8756 16.7534 10.3596L13.1854 13.9276Z"
          fill="#4CAF50"
        />
        <path
          d="M12.1251 13.3672C11.9971 13.3672 11.8691 13.3183 11.7716 13.2208L9.64667 11.0957C9.45111 10.9003 9.45111 10.5842 9.64667 10.3888C9.84213 10.1932 10.1581 10.1932 10.3536 10.3888L12.1251 12.1602L17.1466 7.13878C17.3421 6.94332 17.658 6.94332 17.8536 7.13878C18.049 7.33434 18.049 7.65028 17.8536 7.84584L12.4785 13.2208C12.3811 13.3183 12.2531 13.3672 12.1251 13.3672Z"
          fill="#4CAF50"
        />
      </g>
      <defs>
        <clipPath id="clip99">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const DashboardProfileArrowIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.3335 8H12.6668"
        stroke="#3699FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 3.33301L12.6667 7.99967L8 12.6663"
        stroke="#3699FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ButtonTimesIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 4.75L4.75 14.25"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75 4.75L14.25 14.25"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DashboardWarningTimesIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 4.75L4.75 14.25"
        stroke="#464E5F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75 4.75L14.25 14.25"
        stroke="#464E5F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DashboardVerifyMailIcon = () => {
  return (
    <svg
      width="38"
      height="37"
      viewBox="0 0 38 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="13" y="6" width="25" height="25" rx="6" fill="#C9F7F5" />
      <path
        d="M21.1668 14.167H29.8335C30.4293 14.167 30.9168 14.6545 30.9168 15.2503V21.7503C30.9168 22.3462 30.4293 22.8337 29.8335 22.8337H21.1668C20.571 22.8337 20.0835 22.3462 20.0835 21.7503V15.2503C20.0835 14.6545 20.571 14.167 21.1668 14.167Z"
        stroke="#1BC5BD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.9168 15.25L25.5002 19.0417L20.0835 15.25"
        stroke="#1BC5BD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect width="3" height="37" rx="1.5" fill="#1BC5BD" />
    </svg>
  );
};
export const DashboardVerifyPhoneIcon = () => {
  return (
    <svg
      width="38"
      height="37"
      viewBox="0 0 38 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="13" y="6" width="25" height="25" rx="6" fill="#EEE5FF" />
      <path
        d="M30.9168 21.1647V22.7897C30.9174 22.9406 30.8865 23.0899 30.826 23.2281C30.7656 23.3663 30.677 23.4904 30.5658 23.5924C30.4547 23.6944 30.3234 23.772 30.1805 23.8204C30.0376 23.8687 29.8862 23.8866 29.7359 23.8731C28.0691 23.6919 26.4681 23.1224 25.0614 22.2101C23.7526 21.3785 22.643 20.2689 21.8114 18.9601C20.8959 17.547 20.3262 15.9382 20.1484 14.2639C20.1349 14.1141 20.1527 13.9631 20.2007 13.8206C20.2487 13.6781 20.3259 13.5471 20.4273 13.436C20.5287 13.3249 20.6521 13.2362 20.7897 13.1754C20.9272 13.1147 21.076 13.0832 21.2264 13.0831H22.8514C23.1142 13.0805 23.3691 13.1736 23.5684 13.345C23.7677 13.5164 23.8979 13.7544 23.9347 14.0147C24.0033 14.5348 24.1305 15.0454 24.3139 15.5368C24.3867 15.7307 24.4025 15.9414 24.3593 16.144C24.3161 16.3465 24.2157 16.5325 24.0701 16.6797L23.3822 17.3676C24.1533 18.7237 25.2761 19.8466 26.6322 20.6176L27.3201 19.9297C27.4674 19.7841 27.6533 19.6837 27.8559 19.6405C28.0584 19.5973 28.2691 19.6131 28.463 19.686C28.9545 19.8694 29.4651 19.9966 29.9851 20.0651C30.2482 20.1023 30.4885 20.2348 30.6603 20.4375C30.8321 20.6403 30.9234 20.8991 30.9168 21.1647Z"
        stroke="#8950FC"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect width="3" height="37" rx="1.5" fill="#8950FC" />
    </svg>
  );
};
export const DashboardDatePickerCalendarIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.80859 12.7969C9.80859 13.5723 10.4394 14.2031 11.2148 14.2031H12.8672C13.6426 14.2031 14.2734 13.5723 14.2734 12.7969V11.1445C14.2734 10.3691 13.6426 9.73828 12.8672 9.73828H11.2148C10.4394 9.73828 9.80859 10.3691 9.80859 11.1445V12.7969ZM11.2148 11.1445H12.8672L12.8681 12.7968C12.8681 12.7968 12.8678 12.7969 12.8672 12.7969H11.2148V11.1445Z"
        fill="#80808F"
      />
      <path
        d="M13.5703 8.08594C13.9586 8.08594 14.2734 7.77114 14.2734 7.38281C14.2734 6.99449 13.9586 6.67969 13.5703 6.67969C13.182 6.67969 12.8672 6.99449 12.8672 7.38281C12.8672 7.77114 13.182 8.08594 13.5703 8.08594Z"
        fill="#80808F"
      />
      <path
        d="M10.5117 8.08594C10.9 8.08594 11.2148 7.77114 11.2148 7.38281C11.2148 6.99449 10.9 6.67969 10.5117 6.67969C10.1234 6.67969 9.80859 6.99449 9.80859 7.38281C9.80859 7.77114 10.1234 8.08594 10.5117 8.08594Z"
        fill="#80808F"
      />
      <path
        d="M17.2969 12.375C17.6852 12.375 18 12.0602 18 11.6719V4.21875C18 2.66794 16.7383 1.40625 15.1875 1.40625H14.2734V0.703125C14.2734 0.314789 13.9586 0 13.5703 0C13.182 0 12.8672 0.314789 12.8672 0.703125V1.40625H9.66797V0.703125C9.66797 0.314789 9.35318 0 8.96484 0C8.57651 0 8.26172 0.314789 8.26172 0.703125V1.40625H5.09766V0.703125C5.09766 0.314789 4.78287 0 4.39453 0C4.0062 0 3.69141 0.314789 3.69141 0.703125V1.40625H2.8125C1.26169 1.40625 0 2.66794 0 4.21875V15.1875C0 16.7383 1.26169 18 2.8125 18H15.1875C16.7383 18 18 16.7383 18 15.1875C18 14.7992 17.6852 14.4844 17.2969 14.4844C16.9085 14.4844 16.5938 14.7992 16.5938 15.1875C16.5938 15.9629 15.9629 16.5938 15.1875 16.5938H2.8125C2.03709 16.5938 1.40625 15.9629 1.40625 15.1875V4.21875C1.40625 3.44334 2.03709 2.8125 2.8125 2.8125H3.69141V3.51562C3.69141 3.90396 4.0062 4.21875 4.39453 4.21875C4.78287 4.21875 5.09766 3.90396 5.09766 3.51562V2.8125H8.26172V3.51562C8.26172 3.90396 8.57651 4.21875 8.96484 4.21875C9.35318 4.21875 9.66797 3.90396 9.66797 3.51562V2.8125H12.8672V3.51562C12.8672 3.90396 13.182 4.21875 13.5703 4.21875C13.9586 4.21875 14.2734 3.90396 14.2734 3.51562V2.8125H15.1875C15.9629 2.8125 16.5938 3.44334 16.5938 4.21875V11.6719C16.5938 12.0602 16.9085 12.375 17.2969 12.375Z"
        fill="#80808F"
      />
      <path
        d="M4.39453 14.2031C4.78286 14.2031 5.09766 13.8883 5.09766 13.5C5.09766 13.1117 4.78286 12.7969 4.39453 12.7969C4.00621 12.7969 3.69141 13.1117 3.69141 13.5C3.69141 13.8883 4.00621 14.2031 4.39453 14.2031Z"
        fill="#80808F"
      />
      <path
        d="M4.39453 8.08594C4.78286 8.08594 5.09766 7.77114 5.09766 7.38281C5.09766 6.99449 4.78286 6.67969 4.39453 6.67969C4.00621 6.67969 3.69141 6.99449 3.69141 7.38281C3.69141 7.77114 4.00621 8.08594 4.39453 8.08594Z"
        fill="#80808F"
      />
      <path
        d="M4.39453 11.1445C4.78286 11.1445 5.09766 10.8297 5.09766 10.4414C5.09766 10.0531 4.78286 9.73828 4.39453 9.73828C4.00621 9.73828 3.69141 10.0531 3.69141 10.4414C3.69141 10.8297 4.00621 11.1445 4.39453 11.1445Z"
        fill="#80808F"
      />
      <path
        d="M7.45312 11.1445C7.84145 11.1445 8.15625 10.8297 8.15625 10.4414C8.15625 10.0531 7.84145 9.73828 7.45312 9.73828C7.0648 9.73828 6.75 10.0531 6.75 10.4414C6.75 10.8297 7.0648 11.1445 7.45312 11.1445Z"
        fill="#80808F"
      />
      <path
        d="M7.45312 8.08594C7.84145 8.08594 8.15625 7.77114 8.15625 7.38281C8.15625 6.99449 7.84145 6.67969 7.45312 6.67969C7.0648 6.67969 6.75 6.99449 6.75 7.38281C6.75 7.77114 7.0648 8.08594 7.45312 8.08594Z"
        fill="#80808F"
      />
      <path
        d="M7.45312 14.2031C7.84145 14.2031 8.15625 13.8883 8.15625 13.5C8.15625 13.1117 7.84145 12.7969 7.45312 12.7969C7.0648 12.7969 6.75 13.1117 6.75 13.5C6.75 13.8883 7.0648 14.2031 7.45312 14.2031Z"
        fill="#80808F"
      />
    </svg>
  );
};
export const ToastMenuSuccessIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="#34D399"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ToastMenuWarningIcon = () => {
  return (
    <svg
      height="24"
      viewBox="0 0 512 512"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#E61010"
        d="m256 512c-141.164062 0-256-114.835938-256-256s114.835938-256 256-256 256 114.835938 256 256-114.835938 256-256 256zm0-480c-123.519531 0-224 100.480469-224 224s100.480469 224 224 224 224-100.480469 224-224-100.480469-224-224-224zm0 0"
      />
      <path
        fill="#E61010"
        d="m176.8125 351.1875c-4.097656 0-8.195312-1.554688-11.308594-4.691406-6.25-6.25-6.25-16.382813 0-22.632813l158.398438-158.402343c6.253906-6.25 16.386718-6.25 22.636718 0s6.25 16.382812 0 22.636718l-158.402343 158.398438c-3.15625 3.136718-7.25 4.691406-11.324219 4.691406zm0 0"
      />
      <path
        fill="#E61010"
        d="m335.1875 351.1875c-4.09375 0-8.191406-1.554688-11.304688-4.691406l-158.398437-158.378906c-6.253906-6.25-6.253906-16.382813 0-22.632813 6.25-6.253906 16.382813-6.253906 22.632813 0l158.398437 158.398437c6.253906 6.25 6.253906 16.382813 0 22.632813-3.132813 3.117187-7.230469 4.671875-11.328125 4.671875zm0 0"
      />
    </svg>
  );
};
export const ToastMenuTimesIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z"
        fill="#9CA3AF"
      />
    </svg>
  );
};
export const EditIconDashboard = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 3H3C2.60218 3 2.22064 3.15804 1.93934 3.43934C1.65804 3.72064 1.5 4.10218 1.5 4.5V15C1.5 15.3978 1.65804 15.7794 1.93934 16.0607C2.22064 16.342 2.60218 16.5 3 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V9.75"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.875 1.87517C14.1734 1.5768 14.578 1.40918 15 1.40918C15.422 1.40918 15.8266 1.5768 16.125 1.87517C16.4234 2.17354 16.591 2.57821 16.591 3.00017C16.591 3.42213 16.4234 3.8268 16.125 4.12517L9 11.2502L6 12.0002L6.75 9.00017L13.875 1.87517Z"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EditIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 3H3C2.60218 3 2.22064 3.15804 1.93934 3.43934C1.65804 3.72064 1.5 4.10218 1.5 4.5V15C1.5 15.3978 1.65804 15.7794 1.93934 16.0607C2.22064 16.342 2.60218 16.5 3 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V9.75"
        stroke="#3699FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.875 1.87517C14.1734 1.5768 14.578 1.40918 15 1.40918C15.422 1.40918 15.8266 1.5768 16.125 1.87517C16.4234 2.17354 16.591 2.57821 16.591 3.00017C16.591 3.42213 16.4234 3.8268 16.125 4.12517L9 11.2502L6 12.0002L6.75 9.00017L13.875 1.87517Z"
        stroke="#3699FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ResendIconDashboard = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 2V5H8.5"
        stroke="#3699FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2449 7.50001C9.91992 8.41996 9.30471 9.20937 8.49202 9.74926C7.67932 10.2892 6.71317 10.5503 5.73915 10.4933C4.76513 10.4363 3.83602 10.0643 3.09182 9.43334C2.34762 8.80237 1.82865 7.94662 1.61312 6.99503C1.39759 6.04345 1.49718 5.0476 1.89687 4.15754C2.29656 3.26748 2.97471 2.53144 3.82912 2.06033C4.68352 1.58921 5.6679 1.40856 6.63392 1.54558C7.59993 1.6826 8.49525 2.12988 9.18494 2.82001L11.4999 5.00001"
        stroke="#3699FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EyeIcon = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      width="24"
      viewBox="0 0 469.333 469.333"
      space="preserve"
    >
      <path
        fill={"#2f3044"}
        d="M234.667,170.667c-35.307,0-64,28.693-64,64s28.693,64,64,64s64-28.693,64-64S269.973,170.667,234.667,170.667z"
      />
      <path
        fill={"#2f3044"}
        d="M234.667,74.667C128,74.667,36.907,141.013,0,234.667c36.907,93.653,128,160,234.667,160
				c106.773,0,197.76-66.347,234.667-160C432.427,141.013,341.44,74.667,234.667,74.667z M234.667,341.333
				c-58.88,0-106.667-47.787-106.667-106.667S175.787,128,234.667,128s106.667,47.787,106.667,106.667
				S293.547,341.333,234.667,341.333z"
      />
    </svg>
  );
};
export const EyeInvisibleIcon = () => {
  return (
    <svg
      version="1.1"
      id="Capa_2"
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      width="24"
      viewBox="0 0 469.44 469.44"
      space="preserve"
    >
      <path
        fill={"#2f3044"}
        d="M231.147,160.373l67.2,67.2l0.32-3.52c0-35.307-28.693-64-64-64L231.147,160.373z"
      />
      <path
        fill={"#2f3044"}
        d="M234.667,117.387c58.88,0,106.667,47.787,106.667,106.667c0,13.76-2.773,26.88-7.573,38.933l62.4,62.4
				c32.213-26.88,57.6-61.653,73.28-101.333c-37.013-93.653-128-160-234.773-160c-29.867,0-58.453,5.333-85.013,14.933l46.08,45.973
				C207.787,120.267,220.907,117.387,234.667,117.387z"
      />
      <path
        fill={"#2f3044"}
        d="M21.333,59.253l48.64,48.64l9.707,9.707C44.48,145.12,16.64,181.707,0,224.053c36.907,93.653,128,160,234.667,160
				c33.067,0,64.64-6.4,93.547-18.027l9.067,9.067l62.187,62.293l27.2-27.093L48.533,32.053L21.333,59.253z M139.307,177.12
				l32.96,32.96c-0.96,4.587-1.6,9.173-1.6,13.973c0,35.307,28.693,64,64,64c4.8,0,9.387-0.64,13.867-1.6l32.96,32.96
				c-14.187,7.04-29.973,11.307-46.827,11.307C175.787,330.72,128,282.933,128,224.053C128,207.2,132.267,191.413,139.307,177.12z"
      />
    </svg>
  );
};
